// const realismModifiers = [
//     "realistic textures",
//     "sharp focus",
//     "high resolution",
//     "photorealistic details",
//     "naturalistic colors",
//     "accurate lighting",
//     "lifelike textures",
//     "realistic shadows",
//     "true-to-life details",
//     "believable depth of field",
//     "realistic reflections",
//     "convincing movement",
//     "realistic skin tones",
//     "realistic weather effects"];
// const shotModifiers = [
//     "35mm lens",
//     "85mm lens",
//     "200mm lens",
//     "50mm lens",
//     "24mm lens",
//     "100mm lens",
//     "telephoto lens",
//     "wide-angle lens"];

// let artKeywordListeners = [
//     "painting",
//     "drawing",
//     "illustration",
//     "artwork",
//     "art",
//     "art piece",
//     "painting",
//     "drawing",
//     "illustration",
//     "animation",
//     "animated",
//     "animated art",
//     "cartoon"];
// let artStyles = [
//     "Surrealism, with a focus on dreamlike landscapes, abstract shapes, and a juxtaposition of elements, inspired by Salvador Dali and Max Ernst",
//     "Expressionism, with a focus on bold colors, brushstrokes, and emotions, inspired by Vincent Van Gogh and Edvard Munch",
//     "Futurism, with a focus on sleek and metallic surfaces, industrial landscapes, and technology, inspired by Gino Severini and H.R Giger",
//     "Impressionism, with a focus on light, movement, and color, inspired by Claude Monet and Pierre-Auguste Renoir",
//     "Cubism, with a focus on geometric shapes, multiple perspectives, and collage, inspired by Pablo Picasso and Georges Braque",
//     "Realism, with a focus on photorealistic details, textures, and accuracy, inspired by Chuck Close and Richard Estes",
//     "Surrealism, with a focus on disorienting perspectives, abstract shapes, and impossible constructions, inspired by M.C Escher and Salvador Dali",
//     "Fantasy Art, with a focus on vivid colors, whimsical imagery, and fantastical elements, inspired by J.R.R Tolkien and Brian Froud",
//     "Abstract Expressionism, with a focus on non-representational forms, gestural brushstrokes, and the artist's emotions, inspired by Jackson Pollock and Mark Rothko",
//     "Art Nouveau, with a focus on organic shapes, asymmetry, and ornate decoration, inspired by Alphonse Mucha and Gustav Klimt",
//     "Pop Art, with a focus on popular culture, consumerism, and irony, inspired by Andy Warhol and Roy Lichtenstein",
//     "Dada, with a focus on randomness, nonsense, and anti-art sentiments, inspired by Marcel Duchamp and Hannah Höch",
//     "Art Deco, with a focus on geometric shapes, bold colors, and luxury, inspired by Erte and Tamara de Lempicka",
//     "Pointillism, with a focus on small, distinct dots of color, and optical mixing, inspired by Georges Seurat and Paul Signac",
//     "Rococo, with a focus on ornate and frivolous decoration, asymmetry, and pastel colors, inspired by Fragonard and Jean-Honoré Fragonard",
//     "Post-Impressionism, with a focus on emotional and symbolic content, vibrant colors, and thick paint, inspired by Paul Cezanne and Vincent van Gogh",
//     "Neo-Expressionism, with a focus on intense colors, gestural brushstrokes, and raw emotions, inspired by Jean-Michel Basquiat and Julian Schnabel",
//     "Hyperrealism, with a focus on photorealistic details, textures, and accuracy, inspired by Richard Estes and Denis Peterson",
//     "Op Art, with a focus on optical illusions, geometric shapes, and the interaction of light and color, inspired by Victor Vasarely and Bridget Riley",
//     "Art Brut, with a focus on raw, untrained, and intuitive art, inspired by Jean Dubuffet and Henry Darger",
//     "Minimalism, with a focus on simplicity, negative space, and geometric shapes, inspired by Donald Judd and Agnes Martin"];
let architecture = [
    "Minimalist",
    "Eclectic architecture",
    "Reflective",
    "Congested",
    "Streamlined",
    "Opaque",
    "Pleasant",
    "Gothic architecture",
    "Gothic Revival architecture",
    "Fabric",
    "Structure",
    "Suspended",
    "Facade",
    "Monolithic",
    "Diminutive",
    "Resemble",
    "Revivalist",
    "Streamline",
    "Economical",
    "Sparse",
    "Luxurious",
    "Compact",
    "Pervasive",
    "Effusive",
    "Tatami",
    "Shoji",
    "Fusuma",
    "Engawa",
    "Genkan",
    "Byzantine architecture",
    "Roman architecture",
    "Romanesque architecture",
    "Islamic architecture",
    "Persian architecture",
    "Renaissance architecture",
    "Baroque architecture",
    "Churrigueresque architecture",
    "Churrigueresco architecture",
    "Rococo architecture",
    "Bauhaus architecture",
    "Art Deco",
    "Art Nouveau",
    "Brutalism architecture",
    "Colonial architecture",
    "Composite architecture",
    "Corinthian architecture",
    "Decorated style",
    "Doric architecture",
    "Early Christian architecture",
    "Early English architecture",
    "Edwardian architecture",
    "Empire architecture",
    "Federation architecture",
    "functionalism",
    "Georgian architecture",
    "International Style",
    "Modernist",
    "Ionic",
    "Jacobean architecture",
    "Louis Quatorze",
    "Louis Quinze",
    "Louis Seize",
    "Louis Treize",
    "Mannerism",
    "Moderne",
    "Moorish architecture",
    "Morisco architecture",
    "Mudéjar architecture",
    "Neoclassicial",
    "Palladian",
    "perpendicular",
    "postmodernism",
    "post-modernism",
    "Queen-Anne architecture",
    "Regency architecture",
    "Saracen architecture",
    "transition",
    "transitional",
    "Tudor architecture",
    "Tuscan architecture",
    "Victorian architecture",
    "Cambodian Khmer architecture",
    "Buddhist architecture",
    "New Indies architecture",
    "French Colonial architecture",
    "Spanish Colonial architecture",
    "Vernacular",
    "Neo-Tropical",
    "Bilateral Symmetry",
    "Horizontal emphasis",
    "Cosmological concept architecture",
    "Imperial architecture",
    "Relgious architecture",
    "Confucius era",
    "Hui Style architecture",
    "Shanxi architecture",
    "Lingnan architecture",
    "Cantonese architecture",
    "Minnan architecture",
    "Hokkien architecture",
    "Hakka architecture",
    "Gan architecture",
    "Yaodong architecture",
    "Tibetan architecture",
    "Xinjiang architecture",
    "Hutong architecture",
    "Longtang architecture",
    "Shikumen architecture",
    "Shanghainese architecture",
    "Meiji architecture",
    "Taishō architecture",
    "Shōwa architecture",
    "Heisei architecture",
    "Meiji period",
    "Taishō period",
    "Shōwa period",
    "Heisei period",
    "Japanese aesthetic",
    "Chinese aesthetic",
    "Korean aesthetic",
    "Russian aesthetic",
    "Eastern Roman",
    "Pagan Roman",
    "Kievan Rus architecture",
    "Muscovite architecture",
    "Imperial Russia architecture",
    "Soviet Union architecture",
    "Postwar Soviet architecture",
    "Modern Russian architecture"
];

// let methods = {
//     async imageModifier(text, index) {
//         let promptModifiers = [
//             "photo-manipulation",
//             "concept art",
//             "character design",
//             "digital painting",
//             "3D rendering",
//             "trending on Artstation",
//             "unreal engine",
//             "ultrarealistic editorial photograph",
//             "Award-Winning Art",
//             "photorealistic",
//             "4k/8k"];
//         const shotModifiers = [
//             "35mm lens",
//             "85mm lens",
//             "200mm lens",
//             "50mm lens",
//             "24mm lens",
//             "100mm lens",
//             "telephoto lens",
//             "wide-angle lens"];
//         let lightModifiers = [
//             "Cinematic Lighting",
//             "At/During Golden Hour",
//             "Golden Hour Sunlight",
//             "Ambient Lighting",
//             "Studio Lighting",
//             "Lens Flare",
//             "backlight",
//             "side-light",
//             "front light",
//             "overcast light",
//             "window light"];
//         let styleModifiers = [
//             "Linocut",
//             "Origami",
//             "made of yarn",
//             "Portrait photograph",
//             "screenshot from Vanity Fair",
//             "Portrait photograph",
//             "screenshot from Vanity Fair",
//             "watercolor painting",
//             "oil painting",
//             "acrylic painting",
//             "pen and ink drawing",
//             "gouache painting"];
//         const realismModifiers = [
//             "realistic textures",
//             "sharp focus",
//             "high resolution",
//             "photorealistic details",
//             "naturalistic colors",
//             "accurate lighting",
//             "lifelike textures",
//             "realistic shadows",
//             "true-to-life details",
//             "believable depth of field",
//             "realistic reflections",
//             "convincing movement",
//             "realistic skin tones",
//             "realistic weather effects"];
//         let stylized = [
//             "Vibrant, abstract, with bold shapes and lines and high resolution",
//             "Futuristic, sleek, with metallic surfaces, neon lighting and sharp focus",
//             "Ethereal, dreamlike, with soft focus and misty landscapes, and sharp details",
//             "Minimalistic, monochrome, with clean lines, negative space, and high clarity",
//             "Dark, moody, with deep shadows and contrasting light, and high resolution",
//             "Surreal, otherworldly, with disorienting perspectives, abstract shapes and sharp details",
//             "Grungy, textured, with a focus on decay and abandonment, and high resolution",
//             "Fantasy, with vivid colors, whimsical imagery, and high resolution",
//             "Surrealistic, with a mix of reality and fantasy and sharp focus",
//             "Psychedelic, with bold patterns, trippy visuals and high resolution",
//             "Impressionistic, with soft brushstrokes, blurred edges and high resolution",
//             "Romantic, with a focus on soft light, intimate moments and high resolution",
//             "Elegant, with a focus on symmetry, refinement and high resolution",
//             "Atmospheric, with a focus on weather, lighting effects and high resolution",
//             "Cinematic, with a focus on dramatic composition, storytelling and high resolution",
//             "Hyperrealistic, with a focus on photorealistic details and textures and high resolution",
//             "Vintage, with a focus on nostalgia, retro aesthetics and high resolution",
//             "Anime-inspired, with bold lines, expressive characters and high resolution",
//             "Fashion-inspired, with a focus on high-end clothing, accessories and high resolution",
//             "Tonal, with a focus on monochromatic color palettes, tone-on-tone contrasts and high resolution"
//         ];
//         let artStyles = [
//             "Surrealism, with a focus on dreamlike landscapes, abstract shapes, and a juxtaposition of elements, inspired by Salvador Dali and Max Ernst",
//             "Expressionism, with a focus on bold colors, brushstrokes, and emotions, inspired by Vincent Van Gogh and Edvard Munch",
//             "Futurism, with a focus on sleek and metallic surfaces, industrial landscapes, and technology, inspired by Gino Severini and H.R Giger",
//             "Impressionism, with a focus on light, movement, and color, inspired by Claude Monet and Pierre-Auguste Renoir",
//             "Cubism, with a focus on geometric shapes, multiple perspectives, and collage, inspired by Pablo Picasso and Georges Braque",
//             "Realism, with a focus on photorealistic details, textures, and accuracy, inspired by Chuck Close and Richard Estes",
//             "Surrealism, with a focus on disorienting perspectives, abstract shapes, and impossible constructions, inspired by M.C Escher and Salvador Dali",
//             "Fantasy Art, with a focus on vivid colors, whimsical imagery, and fantastical elements, inspired by J.R.R Tolkien and Brian Froud",
//             "Abstract Expressionism, with a focus on non-representational forms, gestural brushstrokes, and the artist's emotions, inspired by Jackson Pollock and Mark Rothko",
//             "Art Nouveau, with a focus on organic shapes, asymmetry, and ornate decoration, inspired by Alphonse Mucha and Gustav Klimt",
//             "Pop Art, with a focus on popular culture, consumerism, and irony, inspired by Andy Warhol and Roy Lichtenstein",
//             "Dada, with a focus on randomness, nonsense, and anti-art sentiments, inspired by Marcel Duchamp and Hannah Höch",
//             "Art Deco, with a focus on geometric shapes, bold colors, and luxury, inspired by Erte and Tamara de Lempicka",
//             "Pointillism, with a focus on small, distinct dots of color, and optical mixing, inspired by Georges Seurat and Paul Signac",
//             "Rococo, with a focus on ornate and frivolous decoration, asymmetry, and pastel colors, inspired by Fragonard and Jean-Honoré Fragonard",
//             "Post-Impressionism, with a focus on emotional and symbolic content, vibrant colors, and thick paint, inspired by Paul Cezanne and Vincent van Gogh",
//             "Neo-Expressionism, with a focus on intense colors, gestural brushstrokes, and raw emotions, inspired by Jean-Michel Basquiat and Julian Schnabel",
//             "Hyperrealism, with a focus on photorealistic details, textures, and accuracy, inspired by Richard Estes and Denis Peterson",
//             "Op Art, with a focus on optical illusions, geometric shapes, and the interaction of light and color, inspired by Victor Vasarely and Bridget Riley",
//             "Art Brut, with a focus on raw, untrained, and intuitive art, inspired by Jean Dubuffet and Henry Darger",
//             "Minimalism, with a focus on simplicity, negative space, and geometric shapes, inspired by Donald Judd and Agnes Martin"
//         ];
//         let artKeywordListeners = [
//             "painting",
//             "drawing",
//             "illustration",
//             "artwork",
//             "art",
//             "art piece",
//             "painting",
//             "drawing",
//             "illustration",
//             "animation",
//             "animated",
//             "animated art",
//             "cartoon"];
//         let photographyKeywordListeners = [
//             "photograph",
//             "photography",
//             "photo",
//             "photo of",
//             "photograph of",
//             "photography of"
//         ];
//         let shotModifier = shotModifiers[Math.floor(Math.random() * shotModifiers.length)];
//         let lightModifier = lightModifier[Math.floor(Math.random() * lightModifier.length)];
//         let styleModifier = styleModifiers[Math.floor(Math.random() * styleModifiers.length)];
//         let promptModifier = promptModifiers[Math.floor(Math.random() * promptModifiers.length)];
//         let stylizedModifier = stylized[Math.floor(Math.random() * stylized.length)];
//         let combinedModifier = ` ${stylizedModifier}. ${promptModifier} ${shotModifier} ${lightModifier} ${styleModifier} `;
//         let artStyle = artStyles[Math.floor(Math.random() * artStyles.length)];
//         if (text.includes("illustration")) {
//             text = `${text} ${artStyle}`;
//         } else if (text.includes("illustration")) {
//             text = `${text} ${stylizedModifier}`;
//         }
//     },
//     async imageModifier(text, index) {
//         let shotModifier = shotModifiers[Math.floor(Math.random() * shotModifiers.length)];
//         let lightModifier = lightModifier[Math.floor(Math.random() * lightModifier.length)];
//         let styleModifier = styleModifiers[Math.floor(Math.random() * styleModifiers.length)];
//         let promptModifier = promptModifiers[Math.floor(Math.random() * promptModifiers.length)];
//         let stylizedModifier = stylized[Math.floor(Math.random() * stylized.length)];
//         let combinedModifier = ` ${stylizedModifier}. ${promptModifier} ${shotModifier} ${lightModifier} ${styleModifier} `;
//         let artStyle = artStyles[Math.floor(Math.random() * artStyles.length)];
//         if (text.includes("illustration")) {
//             text = `${text} ${artStyle}`;
//         } else if (text.includes("illustration")) {
//             text = `${text} ${stylizedModifier}`;
//         }
//     },
// };
// let stylized = [
//     "Vibrant, abstract, with bold shapes and lines and high resolution",
//     "Futuristic, sleek, with metallic surfaces, neon lighting and sharp focus",
//     "Ethereal, dreamlike, with soft focus and misty landscapes, and sharp details",
//     "Minimalistic, monochrome, with clean lines, negative space, and high clarity",
//     "Dark, moody, with deep shadows and contrasting light, and high resolution",
//     "Surreal, otherworldly, with disorienting perspectives, abstract shapes and sharp details",
//     "Grungy, textured, with a focus on decay and abandonment, and high resolution",
//     "Fantasy, with vivid colors, whimsical imagery, and high resolution",
//     "Surrealistic, with a mix of reality and fantasy and sharp focus",
//     "Psychedelic, with bold patterns, trippy visuals and high resolution",
//     "Impressionistic, with soft brushstrokes, blurred edges and high resolution",
//     "Romantic, with a focus on soft light, intimate moments and high resolution",
//     "Elegant, with a focus on symmetry, refinement and high resolution",
//     "Atmospheric, with a focus on weather, lighting effects and high resolution",
//     "Cinematic, with a focus on dramatic composition, storytelling and high resolution",
//     "Hyperrealistic, with a focus on photorealistic details and textures and high resolution",
//     "Vintage, with a focus on nostalgia, retro aesthetics and high resolution",
//     "Anime-inspired, with bold lines, expressive characters and high resolution",
//     "Fashion-inspired, with a focus on high-end clothing, accessories and high resolution",
//     "Tonal, with a focus on monochromatic color palettes, tone-on-tone contrasts and high resolution"];

// let artKeywordListeners = [
//     "painting",
//     "drawing",
//     "illustration",
//     "artwork",
//     "art",
//     "art piece",
//     "painting",
//     "drawing",
//     "illustration",
//     "animation",
//     "animated",
//     "animated art",
//     "cartoon"];
// let photographyKeywordListeners = [
//     "photograph",
//     "photography",
//     "photo",
//     "photo of",
//     "photograph of",
//     "photography of"];
// let promptModifiers = [
//     "photo-manipulation",
//     "concept art",
//     "character design",
//     "digital painting",
//     "3D rendering",
//     "trending on Artstation",
//     "unreal engine",
//     "ultrarealistic editorial photograph",
//     "Award-Winning Art",
//     "photorealistic",
//     "4k/8k"];
// const shotModifiers = [
//     "35mm lens",
//     "85mm lens",
//     "200mm lens",
//     "50mm lens",
//     "24mm lens",
//     "100mm lens",
//     "telephoto lens",
//     "wide-angle lens"];
// let lightModifiers = [
//     "Cinematic Lighting",
//     "At/During Golden Hour",
//     "Golden Hour Sunlight",
//     "Ambient Lighting",
//     "Studio Lighting",
//     "Lens Flare",
//     "backlight",
//     "side-light",
//     "front light",
//     "overcast light",
//     "window light"];
// let styleModifiers = [
//     "Linocut",
//     "Origami",
//     "made of yarn",
//     "Portrait photograph",
//     "screenshot from Vanity Fair",
//     "watercolor painting",
//     "oil painting",
//     "acrylic painting",
//     "pen and ink drawing",
//     "gouache painting"];
// const realismModifiers = [
//     "realistic textures",
//     "sharp focus",
//     "high resolution",
//     "photorealistic details",
//     "naturalistic colors",
//     "accurate lighting",
//     "lifelike textures",
//     "realistic shadows",
//     "true-to-life details",
//     "believable depth of field",
//     "realistic reflections",
//     "convincing movement",
//     "realistic skin tones",
//     "realistic weather effects"];
// let photographyKeywordListeners = [
//     "photo of",
//     "photo",
//     "photograph of",
//     "photograph",
//     "photography of",
//     "photography",
// ];
// let promptModifiers = [
//     "photo-manipulation",
//     "concept art",
//     "character design",
//     "digital painting",
//     "3D rendering",
//     "trending on Artstation",
//     "unreal engine",
//     "ultrarealistic editorial photograph",
//     "Award-Winning Art",
//     "photorealistic",
//     "4k/8k"
// ];
// let lightModifiers = [
//     "Cinematic Lighting",
//     "At/During Golden Hour",
//     "Golden Hour Sunlight",
//     "Ambient Lighting",
//     "Studio Lighting",
//     "Lens Flare",
//     "backlight",
//     "side-light",
//     "front light",
//     "overcast light",
//     "window light"
// ];
// let styleModifiers = [
//     "Linocut",
//     "Origami",
//     "Portrait photograph",
//     "acrylic painting",
//     "gouache painting",
//     "made of yarn",
//     "oil painting",
//     "pen and ink drawing",
//     "screenshot from Vanity Fair",
//     "watercolor painting",
// ];
// let artStyles = [
//     "Surrealism, with a focus on dreamlike landscapes, abstract shapes, and a juxtaposition of elements, inspired by Salvador Dali and Max Ernst",
//     "Expressionism, with a focus on bold colors, brushstrokes, and emotions, inspired by Vincent Van Gogh and Edvard Munch",
//     "Futurism, with a focus on sleek and metallic surfaces, industrial landscapes, and technology, inspired by Gino Severini and H.R Giger",
//     "Impressionism, with a focus on light, movement, and color, inspired by Claude Monet and Pierre-Auguste Renoir",
//     "Cubism, with a focus on geometric shapes, multiple perspectives, and collage, inspired by Pablo Picasso and Georges Braque",
//     "Realism, with a focus on photorealistic details, textures, and accuracy, inspired by Chuck Close and Richard Estes",
//     "Surrealism, with a focus on disorienting perspectives, abstract shapes, and impossible constructions, inspired by M.C Escher and Salvador Dali",
//     "Fantasy Art, with a focus on vivid colors, whimsical imagery, and fantastical elements, inspired by J.R.R Tolkien and Brian Froud",
//     "Abstract Expressionism, with a focus on non-representational forms, gestural brushstrokes, and the artist's emotions, inspired by Jackson Pollock and Mark Rothko",
//     "Art Nouveau, with a focus on organic shapes, asymmetry, and ornate decoration, inspired by Alphonse Mucha and Gustav Klimt",
//     "Pop Art, with a focus on popular culture, consumerism, and irony, inspired by Andy Warhol and Roy Lichtenstein",
//     "Dada, with a focus on randomness, nonsense, and anti-art sentiments, inspired by Marcel Duchamp and Hannah Höch",
//     "Art Deco, with a focus on geometric shapes, bold colors, and luxury, inspired by Erte and Tamara de Lempicka",
//     "Pointillism, with a focus on small, distinct dots of color, and optical mixing, inspired by Georges Seurat and Paul Signac",
//     "Rococo, with a focus on ornate and frivolous decoration, asymmetry, and pastel colors, inspired by Fragonard and Jean-Honoré Fragonard",
//     "Post-Impressionism, with a focus on emotional and symbolic content, vibrant colors, and thick paint, inspired by Paul Cezanne and Vincent van Gogh",
//     "Neo-Expressionism, with a focus on intense colors, gestural brushstrokes, and raw emotions, inspired by Jean-Michel Basquiat and Julian Schnabel",
//     "Hyperrealism, with a focus on photorealistic details, textures, and accuracy, inspired by Richard Estes and Denis Peterson",
//     "Op Art, with a focus on optical illusions, geometric shapes, and the interaction of light and color, inspired by Victor Vasarely and Bridget Riley",
//     "Art Brut, with a focus on raw, untrained, and intuitive art, inspired by Jean Dubuffet and Henry Darger",
//     "Minimalism, with a focus on simplicity, negative space, and geometric shapes, inspired by Donald Judd and Agnes Martin"
// ];
// let stylized = [
//     "Vibrant, abstract, with bold shapes and lines and high resolution",
//     "Futuristic, sleek, with metallic surfaces, neon lighting and sharp focus",
//     "Ethereal, dreamlike, with soft focus and misty landscapes, and sharp details",
//     "Minimalistic, monochrome, with clean lines, negative space, and high clarity",
//     "Dark, moody, with deep shadows and contrasting light, and high resolution",
//     "Surreal, otherworldly, with disorienting perspectives, abstract shapes and sharp details",
//     "Grungy, textured, with a focus on decay and abandonment, and high resolution",
//     "Fantasy, with vivid colors, whimsical imagery, and high resolution",
//     "Surrealistic, with a mix of reality and fantasy and sharp focus",
//     "Psychedelic, with bold patterns, trippy visuals and high resolution",
//     "Impressionistic, with soft brushstrokes, blurred edges and high resolution",
//     "Romantic, with a focus on soft light, intimate moments and high resolution",
//     "Elegant, with a focus on symmetry, refinement and high resolution",
//     "Atmospheric, with a focus on weather, lighting effects and high resolution",
//     "Cinematic, with a focus on dramatic composition, storytelling and high resolution",
//     "Hyperrealistic, with a focus on photorealistic details and textures and high resolution",
//     "Vintage, with a focus on nostalgia, retro aesthetics and high resolution",
//     "Anime-inspired, with bold lines, expressive characters and high resolution",
//     "Fashion-inspired, with a focus on high-end clothing, accessories and high resolution",
//     "Tonal, with a focus on monochromatic color palettes, tone-on-tone contrasts and high resolution"
// ];
let popCulture = [
    "3DO Interactive Multiplayer",
    "A Clockwork Orange (1971)",
    "Adventure Time",
    "Agent 007",
    "Ahh! Real Monsters",
    "Alien (1979)",
    "Aliens (1986)",
    "Animaniacs",
    "Atari",
    "Attack on Titan",
    "Batman",
    "Batman: The Animated Series",
    "BeastWars",
    "Beetlejuice",
    "Ben Hur",
    "Black Lagoon",
    "Blade Runner",
    "Blazing Saddles",
    "Bleach",
    "Braveheart (1995)",
    "Breakfast at Tiffany's",
    "Call of Duty",
    "Call of Duty Modern Warfare",
    "Casablanca",
    "CatDog",
    "Chip 'n Dale: Rescue Rangers",
    "Close Encounters of the Third Kind",
    "Code Geass",
    "Comic-Con",
    "Contact (1997)",
    "Courage the Cowardly Dog",
    "Cowboy Bebop",
    "Danger Mouse",
    "Dark Souls",
    "Darkwing Duck",
    "Death Note",
    "Demons Souls",
    "Dexter's Laboratory",
    "Die Hard",
    "Digimon",
    "Dragon Ball",
    "Dragon Ball GT",
    "Dragon Ball Super",
    "Dragon Ball Z",
    "E.T. the Extra-Terrestrial (1982)",
    "Earthworm Jim",
    "Elden Ring",
    "Ewoks",
    "FLCL",
    "Fooly Cooly",
    "Fortnite",
    "Full Metal Jacket (1987)",
    "Fullmetal Alchemist",
    "Futurama",
    "Game Boy",
    "Game Boy Advance",
    "Game Boy Color",
    "Game Boy SP",
    "Gargoyles",
    "George Lucas",
    "Ghostbusters",
    "Goldfinger",
    "Gone with the Wind (1939)",
    "Gundam",
    "He-Man and the Masters of the Universe",
    "Hellsing",
    "Inuyasha",
    "James Bond",
    "Johnny Bravo",
    "Jurassic Park",
    "Jurassic Park III",
    "Jurassic World",
    "Jurassic World Dominion",
    "Jurassic World Fallen Kingdom",
    "Justice League",
    "King Kong",
    "M.A.S.H.",
    "MASH",
    "Mad Max",
    "Mad Max 2: The Road Warrior",
    "Mad Max Beyond Thunderdome",
    "Mad Max: Fury Road",
    "Magic: The Gathering",
    "MechWarrior",
    "Mega Man",
    "Megan Man X",
    "Metabots",
    "Michael Crichton",
    "Mighty Max",
    "Naruto",
    "Neon Genesis Evangelion",
    "Nintendo",
    "Nintendo 3DS",
    "Nintendo 64",
    "Nintendo DS",
    "Nintendo Entertainment System",
    "Nintendo Switch",
    "Nintendo Wii",
    "Nintendo WiiU",
    "Overwatch",
    "PAX",
    "PC Engine",
    "Pinky and the Brain",
    "Planet of the Apes",
    "Pokemon",
    "Poltergeist (1982)",
    "Pulp Fiction",
    "Raiders of the Lost Ark (1981)",
    "Rainbow Brite",
    "ReBoot (1994)",
    "Regular Show",
    "Robotech",
    "Rocko’s Modern Life",
    "Rugrats",
    "SEGA",
    "Samurai Jack",
    "Scary Stories to Tell in the Dark",
    "She-Ra: Princess of Power",
    "Singing in the Rain",
    "Sony Playstation",
    "Sony Playstation 2",
    "Sony Playstation 3",
    "Sony Playstation 4",
    "Sony Playstation 5",
    "Space Dandy",
    "Spider-Man",
    "Spiderman",
    "Star Wars (1977)",
    "Star Wars: Episode V - The Empire Strikes Back (1980)",
    "Starcraft",
    "Steven King",
    "Steven Spielberg",
    "Stranger Things",
    "Street Sharks",
    "Super Mario Bros.",
    "Super Nintendo",
    "Superman",
    "T-1000",
    "T-600",
    "T-800",
    "TaleSpin",
    "Teenage Mutant Ninja Turtles",
    "Terminator 3",
    "Terminator Dark Fate",
    "Terminator Genysis",
    "Terminator Salvation",
    "The Day the Earth Stood Still",
    "The Day the Earth Stood Still (1951)",
    "The Godfather",
    "The Grim Adventures of Billy and Mandy",
    "The Hulk",
    "The Lord of the Rings: The Fellowship of the Ring (2001)",
    "The Lost World",
    "The Matrix",
    "The New Adventures of Johnny Quest",
    "The Poseidon Adventure (1972)",
    "The Ren & Stimpy Show",
    "The Simpsons",
    "The Terminator",
    "The Terminator 2: Judgement Day",
    "The Thing from Another World (1951)",
    "The Wizard of Oz (1939)",
    "Thundercats",
    "Titanic (1997)",
    "Total Recall",
    "Toxic Crusaders",
    "Transformers",
    "Trigun",
    "War for the Planet of the Apes",
    "WarCraft",
    "Wizard of the Coast",
    "X-Men",
    "Xenomorphs",
    "Yu Yu Hakusho"
];
let dat1 = {
    shotModifiers: ["100mm lens", "200mm lens", "24mm lens", "35mm lens", "50mm lens", "85mm lens", "telephoto lens", "wide-angle lens"],
    camera: {
        "f-stop": ["ƒ/1", "ƒ/1.4", "ƒ2", "ƒ/2.8", "ƒ4", "ƒ/5.6", "ƒ/8", "ƒ/11", "ƒ/16", "ƒ/22"],
        "iso-stop": ["ISO 100", "ISO 200", "ISO 400", "ISO 800", "ISO 1600", "ISO 3200", "ISO 6400", "ISO 12500", "ISO 25600", "ISO 51200", "ISO 102400", "ISO 204800", "ISO 409600"],
    },
    "hd": ["2k resolution", "4k resolution", "8k resolution", "12k resolution", {
        "name": "Optional",
        array: ["16k resolution", "32k resolution", "High resolution", "High definition", "HD", "HDR"]
    }],
    "style": ["Tempera", "Oil Paints", "Acrylic Paints", "Watercolors", "Charcoals", "Pastels", "Chalks", "Graphite Pencils", "Color Pencils", "Ink and Pen", "Digital Paintings", "Vector Art", "3D Renderings", "3D Path Tracing", "3D Ray Tracing", "3D Sculpting", "Matte Paintings", "Digital Matte Paintings", "2D Animation", "Concept Artist", "Fractal Art", "Algorithmic Art", "Data-Moshing", "Dynamic Paintings", "Digital Collage", "2D Digital Paintings", "3D Digital Paintings", "Integrated Arts", "Mixed-Medium Arts", "Raster Paintings", "Miniature", "Diorama", "Terrarium", "Done in LEGO", "Paper Cut Out", "Voxel", "Pixel Art", "Low Poly", "PSX GRAPHICS", "Retro Graphics", "Generative Art", "Play-Doh", "Botanical Drawing", "Technical drawing", "Optical Illusion"],
    realismModifiers: ["accurate lighting", "believable depth of field", "convincing movement", "high resolution", "lifelike textures", "naturalistic colors", "photorealistic details", "realistic reflections", "realistic shadows", "realistic skin tones", "realistic textures", "realistic weather effects", "sharp focus", "true-to-life details",],
    "PhotoTerms": ["Bokeh", "Depth of Field", "DoF", "Digital Camera", "Optical Camera", "Long Exposure", "Short Exposure", "Over Exposed", "Focused"],
    "3d-terms": ["2D Sprite", "Ambient Lighting", "Ambient Occlusion", "Anti-aliasing", "Augmented Reality", "Bitmap", "Cel shading", "Chromatic Abberation", "Direct Lighting", "Flat shading", "FXAA", "Global Illumination", "Indirect Illumination", "Lumen Global Illumination", "Manhattan Distance", "Microdisplacement", "Nanite Geometry", "Path Traced", "PBR Material", "Phong Shading", "Physically based rendering (PBR)", "Post Processed", "Procedural Generation", "Procedural Texture", "Raster graphics", "Ray Traced", "Screen space ambient occlusion", "Skybox", "Terrain rendering", "Tesselation", "Virtual reality", "Volumetric Lighting", "Voronoi Manhattan", "Voronoi Minkowski", "Voxel Engine", "Voxel Geometry", "Wireframe Model", "Wireframe Rendering"],
    "adj-architecture": ["Minimalist", "Eclectic architecture", "Reflective", "Congested", "Streamlined", "Opaque", "Pleasant", "Gothic architecture", "Gothic Revival architecture", "Fabric", "Structure", "Suspended", "Facade", "Monolithic", "Diminutive", "Resemble", "Revivalist", "Streamline", "Economical", "Sparse", "Luxurious", "Compact", "Pervasive", "Effusive", "Tatami", "Shoji", "Fusuma", "Engawa", "Genkan", "Byzantine architecture", "Roman architecture", "Romanesque architecture", "Islamic architecture", "Persian architecture", "Renaissance architecture", "Baroque architecture", "Churrigueresque architecture", "Churrigueresco architecture", "Rococo architecture", "Bauhaus architecture", "Art Deco", "Art Nouveau", "Brutalism architecture", "Colonial architecture", "Composite architecture", "Corinthian architecture", "Decorated style", "Doric architecture", "Early Christian architecture", "Early English architecture", "Edwardian architecture", "Empire architecture", "Federation architecture", "functionalism", "Georgian architecture", "International Style", "Modernist", "Ionic", "Jacobean architecture", "Louis Quatorze", "Louis Quinze", "Louis Seize", "Louis Treize", "Mannerism", "Moderne", "Moorish architecture", "Morisco architecture", "Mudéjar architecture", "Neoclassicial", "Palladian", "perpendicular", "postmodernism", "post-modernism", "Queen-Anne architecture", "Regency architecture", "Saracen architecture", "transition", "transitional", "Tudor architecture", "Tuscan architecture", "Victorian architecture", "Cambodian Khmer architecture", "Buddhist architecture", "New Indies architecture", "French Colonial architecture", "Spanish Colonial architecture", "Vernacular", "Neo-Tropical", "Bilateral Symmetry", "Horizontal emphasis", "Cosmological concept architecture", "Imperial architecture", "Relgious architecture", "Confucius era", "Hui Style architecture", "Shanxi architecture", "Lingnan architecture", "Cantonese architecture", "Minnan architecture", "Hokkien architecture", "Hakka architecture", "Gan architecture", "Yaodong architecture", "Tibetan architecture", "Xinjiang architecture", "Hutong architecture", "Longtang architecture", "Shikumen architecture", "Shanghainese architecture", "Meiji architecture", "Taishō architecture", "Shōwa architecture", "Heisei architecture", "Meiji period", "Taishō period", "Shōwa period", "Heisei period", "Japanese aesthetic", "Chinese aesthetic", "Korean aesthetic", "Russian aesthetic", "Eastern Roman", "Pagan Roman", "Kievan Rus architecture", "Muscovite architecture", "Imperial Russia architecture", "Soviet Union architecture", "Postwar Soviet architecture", "Modern Russian architecture"],
    "pop-culture": ["3DO Interactive Multiplayer", "A Clockwork Orange (1971)", "Adventure Time", "Agent 007", "Ahh! Real Monsters", "Alien (1979)", "Aliens (1986)", "Animaniacs", "Atari", "Attack on Titan", "Batman", "Batman: The Animated Series", "BeastWars", "Beetlejuice", "Ben Hur", "Black Lagoon", "Blade Runner", "Blazing Saddles", "Bleach", "Braveheart (1995)", "Breakfast at Tiffany's", "Call of Duty", "Call of Duty Modern Warfare", "Casablanca", "CatDog", "Chip 'n Dale: Rescue Rangers", "Close Encounters of the Third Kind", "Code Geass", "Comic-Con", "Contact (1997)", "Courage the Cowardly Dog", "Cowboy Bebop", "Danger Mouse", "Dark Souls", "Darkwing Duck", "Death Note", "Demons Souls", "Dexter's Laboratory", "Die Hard", "Digimon", "Dragon Ball", "Dragon Ball GT", "Dragon Ball Super", "Dragon Ball Z", "E.T. the Extra-Terrestrial (1982)", "Earthworm Jim", "Elden Ring", "Ewoks", "FLCL", "Fooly Cooly", "Fortnite", "Full Metal Jacket (1987)", "Fullmetal Alchemist", "Futurama", "Game Boy", "Game Boy Advance", "Game Boy Color", "Game Boy SP", "Gargoyles", "George Lucas", "Ghostbusters", "Goldfinger", "Gone with the Wind (1939)", "Gundam", "He-Man and the Masters of the Universe", "Hellsing", "Inuyasha", "James Bond", "Johnny Bravo", "Jurassic Park", "Jurassic Park III", "Jurassic World", "Jurassic World Dominion", "Jurassic World Fallen Kingdom", "Justice League", "King Kong", "M.A.S.H.", "MASH", "Mad Max", "Mad Max 2: The Road Warrior", "Mad Max Beyond Thunderdome", "Mad Max: Fury Road", "Magic: The Gathering", "MechWarrior", "Mega Man", "Megan Man X", "Metabots", "Michael Crichton", "Mighty Max", "Naruto", "Neon Genesis Evangelion", "Nintendo", "Nintendo 3DS", "Nintendo 64", "Nintendo DS", "Nintendo Entertainment System", "Nintendo Switch", "Nintendo Wii", "Nintendo WiiU", "Overwatch", "PAX", "PC Engine", "Pinky and the Brain", "Planet of the Apes", "Pokemon", "Poltergeist (1982)", "Pulp Fiction", "Raiders of the Lost Ark (1981)", "Rainbow Brite", "ReBoot (1994)", "Regular Show", "Robotech", "Rocko’s Modern Life", "Rugrats", "SEGA", "Samurai Jack", "Scary Stories to Tell in the Dark", "She-Ra: Princess of Power", "Singing in the Rain", "Sony Playstation", "Sony Playstation 2", "Sony Playstation 3", "Sony Playstation 4", "Sony Playstation 5", "Space Dandy", "Spider-Man", "Spiderman", "Star Wars (1977)", "Star Wars: Episode V - The Empire Strikes Back (1980)", "Starcraft", "Steven King", "Steven Spielberg", "Stranger Things", "Street Sharks", "Super Mario Bros.", "Super Nintendo", "Superman", "T-1000", "T-600", "T-800", "TaleSpin", "Teenage Mutant Ninja Turtles", "Terminator 3", "Terminator Dark Fate", "Terminator Genysis", "Terminator Salvation", "The Day the Earth Stood Still", "The Day the Earth Stood Still (1951)", "The Godfather", "The Grim Adventures of Billy and Mandy", "The Hulk", "The Lord of the Rings: The Fellowship of the Ring (2001)", "The Lost World", "The Matrix", "The New Adventures of Johnny Quest", "The Poseidon Adventure (1972)", "The Ren & Stimpy Show", "The Simpsons", "The Terminator", "The Terminator 2: Judgement Day", "The Thing from Another World (1951)", "The Wizard of Oz (1939)", "Thundercats", "Titanic (1997)", "Total Recall", "Toxic Crusaders", "Transformers", "Trigun", "War for the Planet of the Apes", "WarCraft", "Wizard of the Coast", "X-Men", "Xenomorphs", "Yu Yu Hakusho"],
    "gen-modifier": ["60s kitsch and psychedelia", "abstract illusionism", "ambrotype", "american romanticism", "anaglyph effect", "anaglyph filter", "blueprint", "brutalism", "chillwave", "cottagecore", "crayon art", "cyanotype", "dark academia", "digital art", "dutch golden age", "fractalism", "fresco", "futuresynth", "german romanticism", "glitch art", "gothic art", "graffiti", "hyperrealism", "infrared", "Lovecraftian", "magic realism", "multiple exposure", "narrative realism", "photorealism", "realism", "retrowave", "Sabattier effect", "Sabattier filter", "still life", "street art", "surrealism", "synthwave", "vaporwave", "afrofuturism", "anime", "avant-garde", "calotype", "camcorder effect", "cubism", "daguerreotype", "doge", "expressionism", "figurativism", "fisheye lens", "gothic", "holography", "impressionism", "inverted colors", "long exposure", "mac and cheese", "macro lens", "manga", "modernism", "naturalism", "optical illusion", "positivism", "stuckism", "symbolism", "telephoto lens", "the matrix", "tilt-shift", "tintype", "tonalism"],
    "site": ["trending on ArtStation", "trending on ConceptArtWorld", "trending on Flickr", "trending on Behance", "trending on 500px", "trending on Getty Images", "trending on DeviantArt", "trending on Pixiv", "trending on IllustrationX", "trending on CGSociety", "trending on Unsplash", "trending on Google Images", "trending on Pinterest", "trending on Sketchfab", "trending on Artsy", "National Gallery of Art Highlights", "trending on Saatchi Art"],
};
// let data = {
//     shotModifiers: [
//         "100mm lens",
//         "200mm lens",
//         "24mm lens",
//         "35mm lens",
//         "50mm lens",
//         "85mm lens",
//         "telephoto lens",
//         "wide-angle lens"
//     ],
//     camera: {
//         "f-stop": [
//             "ƒ/1",
//             "ƒ/1.4",
//             "ƒ2",
//             "ƒ/2.8",
//             "ƒ4",
//             "ƒ/5.6",
//             "ƒ/8",
//             "ƒ/11",
//             "ƒ/16",
//             "ƒ/22"
//         ],
//         "iso-stop": [
//             "ISO 100",
//             "ISO 200",
//             "ISO 400",
//             "ISO 800",
//             "ISO 1600",
//             "ISO 3200",
//             "ISO 6400",
//             "ISO 12500",
//             "ISO 25600",
//             "ISO 51200",
//             "ISO 102400",
//             "ISO 204800",
//             "ISO 409600"
//         ],
//         "camera": [
//             "Canon EOS Rebel T7 DSLR Camera",
//             "Sony a7 IV Mirrorless Camera",
//             "Canon EOS R6 Mirrorless Camera",
//             "Canon EOS 5D Mark IV DSLR Camera",
//             "Sony a6600 Mirrorless Camera",
//             "Canon EOS Rebel T7 DSLR Camera",
//             "Canon EOS R6 Mirrorless Camera",
//             "Canon EOS 5D Mark IV DSLR Camera",
//             "Canon EOS RP Mirrorless Camera",
//             "Canon EOS Rebel T8i DSLR Camera",
//             "Canon EOS R5 Mirrorless Camera",
//             "Canon EOS R Mirrorless Camera",
//             "Canon EOS M6 Mark II Mirrorless Camera",
//             "Canon EOS M50 Mark II Mirrorless Camera",
//             "Canon EOS 90D DSLR Camera",
//             "Sony a7 IV Mirrorless Camera",
//             "Sony a6600 Mirrorless Camera",
//             "Sony a7 III Mirrorless Camera",
//             "Sony a6400 Mirrorless Camera",
//             "Sony a7R IV Mirrorless Camera",
//             "Sony a7S III Mirrorless Camera",
//             "Sony ZV-E10 Mirrorless Camera",
//             "Sony a9 II Mirrorless Camera",
//             "Sony a7C Mirrorless Camera",
//             "Sony a6100 Mirrorless Camera",
//             "Nikon Z6 II Mirrorless Camera",
//             "Nikon Z7 II Mirrorless Camera",
//             "Nikon D3500 DSLR Camera",
//             "Nikon D850 DSLR Camera",
//             "Nikon Z fc Mirrorless Camera",
//             "Nikon D7500 DSLR Camera",
//             "Nikon Z5 Mirrorless Camera",
//             "Fujifilm X-H2S Mirrorless Camera",
//             "Fujifilm X-T30 II Mirrorless Camera",
//             "Panasonic Lumix G7 Mirrorless Camera",
//             "Fujifilm X-S10 Mirrorless Camera",
//             "Panasonic Lumix GH6 Mirrorless Camera",
//             "Fujifilm X-T4 Mirrorless Camera",
//             "Panasonic Lumix GH5 II Mirrorless Camera",
//             "Vest Pocket Autographic Kodak Camera",
//             "Kodak 616 Junior Camera",
//             "Kodak 35 Camera",
//             "Kodak PIXPRO FZ43 16MP Digital Camera",
//             "Kodak PIXPRO AZ252 16.15MP Digital Camera",
//             "Kodak PIXPRO FZ152 16MP Digital Camera",
//             "Kodak PIXPRO AZ241 16.15MP Digital Camera",
//             "Kodak PIXPRO AZ401 16MP Digital Camera",
//             "Kodak Smile 10MP Digital Camera",
//             "Yashica T4 Camera",
//             "Konica Hexar AF Camera",
//             "Nikon L35AF Camera",
//             "Olympus XA2 Camera",
//             "Olympus OM-1 Camera",
//             "Nikon F2 Camera",
//             "Nikon FE Camera",
//             "Pentax 67 Camera",
//             "Pentax K1000 Camera",
//             "Canon AE-1 Camera",
//             "Canon A2/A2e Camera",
//             "Plaubel Makina W67 Camera",
//             "Lubitel 2",
//             "Kodak No 3A Folding Pocket Camera",
//             "Canon G III QL17 Camera",
//             "Polaroid SX-70 Alpha Camera",
//             "Graflex Century Graphic 2×3 Camera",
//             "Pentacon Six TL Camera",
//             "Zenza Bronica ETRSi Camera",
//             "Hasselblad 500C Camera",
//             "Contax G1/G2 Camera",
//             "Leica M3 Double Stroke Camera",
//             "Leica M6 Camera",
//             "Horseman 4×5 (45HD) Camera",
//             "Mamiya 7 II Camera"
//         ],
//     },
//     "hd": ["2k resolution",
//         "4k resolution",
//         "8k resolution",
//         "12k resolution",
//         {
//             "name": "Optional",
//             array: ["16k resolution",
//                 "32k resolution",
//                 "High resolution",
//                 "High definition",
//                 "HD",
//                 "HDR"]
//         }
//     ],
//     "style": [
//         "Tempera",
//         "Oil Paints",
//         "Acrylic Paints",
//         "Watercolors",
//         "Charcoals",
//         "Pastels",
//         "Chalks",
//         "Graphite Pencils",
//         "Color Pencils",
//         "Ink and Pen",
//         "Digital Paintings",
//         "Vector Art",
//         "3D Renderings",
//         "3D Path Tracing",
//         "3D Ray Tracing",
//         "3D Sculpting",
//         "Matte Paintings",
//         "Digital Matte Paintings",
//         "2D Animation",
//         "Concept Artist",
//         "Fractal Art",
//         "Algorithmic Art",
//         "Data-Moshing",
//         "Dynamic Paintings",
//         "Digital Collage",
//         "2D Digital Paintings",
//         "3D Digital Paintings",
//         "Integrated Arts",
//         "Mixed-Medium Arts",
//         "Raster Paintings",
//         "Miniature",
//         "Diorama",
//         "Terrarium",
//         "Done in LEGO",
//         "Paper Cut Out",
//         "Voxel",
//         "Pixel Art",
//         "Low Poly",
//         "PSX GRAPHICS",
//         "Retro Graphics",
//         "Generative Art",
//         "Play-Doh",
//         "Botanical Drawing",
//         "Technical drawing",
//         "Optical Illusion"
//     ],
//     realismModifiers: [
//         "accurate lighting",
//         "believable depth of field",
//         "convincing movement",
//         "high resolution",
//         "lifelike textures",
//         "naturalistic colors",
//         "photorealistic details",
//         "realistic reflections",
//         "realistic shadows",
//         "realistic skin tones",
//         "realistic textures",
//         "realistic weather effects",
//         "sharp focus",
//         "true-to-life details",
//     ],
//     "PhotoTerms": [
//         "Bokeh",
//         "Depth of Field",
//         "DoF",
//         "Digital Camera",
//         "Optical Camera",
//         "Long Exposure",
//         "Short Exposure",
//         "Over Exposed",
//         "Focused"
//     ],
//     "3d-terms": [
//         "2D Sprite",
//         "Ambient Lighting",
//         "Ambient Occlusion",
//         "Anti-aliasing",
//         "Augmented Reality",
//         "Bitmap",
//         "Cel shading",
//         "Chromatic Abberation",
//         "Direct Lighting",
//         "Flat shading",
//         "FXAA",
//         "Global Illumination",
//         "Indirect Illumination",
//         "Lumen Global Illumination",
//         "Manhattan Distance",
//         "Microdisplacement",
//         "Nanite Geometry",
//         "Path Traced",
//         "PBR Material",
//         "Phong Shading",
//         "Physically based rendering (PBR)",
//         "Post Processed",
//         "Procedural Generation",
//         "Procedural Texture",
//         "Raster graphics",
//         "Ray Traced",
//         "Screen space ambient occlusion",
//         "Skybox",
//         "Terrain rendering",
//         "Tesselation",
//         "Virtual reality",
//         "Volumetric Lighting",
//         "Voronoi Manhattan",
//         "Voronoi Minkowski",
//         "Voxel Engine",
//         "Voxel Geometry",
//         "Wireframe Model",
//         "Wireframe Rendering"
//     ],
//     "adj-architecture": [
//         "Minimalist",
//         "Eclectic architecture",
//         "Reflective",
//         "Congested",
//         "Streamlined",
//         "Opaque",
//         "Pleasant",
//         "Gothic architecture",
//         "Gothic Revival architecture",
//         "Fabric",
//         "Structure",
//         "Suspended",
//         "Facade",
//         "Monolithic",
//         "Diminutive",
//         "Resemble",
//         "Revivalist",
//         "Streamline",
//         "Economical",
//         "Sparse",
//         "Luxurious",
//         "Compact",
//         "Pervasive",
//         "Effusive",
//         "Tatami",
//         "Shoji",
//         "Fusuma",
//         "Engawa",
//         "Genkan",
//         "Byzantine architecture",
//         "Roman architecture",
//         "Romanesque architecture",
//         "Islamic architecture",
//         "Persian architecture",
//         "Renaissance architecture",
//         "Baroque architecture",
//         "Churrigueresque architecture",
//         "Churrigueresco architecture",
//         "Rococo architecture",
//         "Bauhaus architecture",
//         "Art Deco",
//         "Art Nouveau",
//         "Brutalism architecture",
//         "Colonial architecture",
//         "Composite architecture",
//         "Corinthian architecture",
//         "Decorated style",
//         "Doric architecture",
//         "Early Christian architecture",
//         "Early English architecture",
//         "Edwardian architecture",
//         "Empire architecture",
//         "Federation architecture",
//         "functionalism",
//         "Georgian architecture",
//         "International Style",
//         "Modernist",
//         "Ionic",
//         "Jacobean architecture",
//         "Louis Quatorze",
//         "Louis Quinze",
//         "Louis Seize",
//         "Louis Treize",
//         "Mannerism",
//         "Moderne",
//         "Moorish architecture",
//         "Morisco architecture",
//         "Mudéjar architecture",
//         "Neoclassicial",
//         "Palladian",
//         "perpendicular",
//         "postmodernism",
//         "post-modernism",
//         "Queen-Anne architecture",
//         "Regency architecture",
//         "Saracen architecture",
//         "transition",
//         "transitional",
//         "Tudor architecture",
//         "Tuscan architecture",
//         "Victorian architecture",
//         "Cambodian Khmer architecture",
//         "Buddhist architecture",
//         "New Indies architecture",
//         "French Colonial architecture",
//         "Spanish Colonial architecture",
//         "Vernacular",
//         "Neo-Tropical",
//         "Bilateral Symmetry",
//         "Horizontal emphasis",
//         "Cosmological concept architecture",
//         "Imperial architecture",
//         "Relgious architecture",
//         "Confucius era",
//         "Hui Style architecture",
//         "Shanxi architecture",
//         "Lingnan architecture",
//         "Cantonese architecture",
//         "Minnan architecture",
//         "Hokkien architecture",
//         "Hakka architecture",
//         "Gan architecture",
//         "Yaodong architecture",
//         "Tibetan architecture",
//         "Xinjiang architecture",
//         "Hutong architecture",
//         "Longtang architecture",
//         "Shikumen architecture",
//         "Shanghainese architecture",
//         "Meiji architecture",
//         "Taishō architecture",
//         "Shōwa architecture",
//         "Heisei architecture",
//         "Meiji period",
//         "Taishō period",
//         "Shōwa period",
//         "Heisei period",
//         "Japanese aesthetic",
//         "Chinese aesthetic",
//         "Korean aesthetic",
//         "Russian aesthetic",
//         "Eastern Roman",
//         "Pagan Roman",
//         "Kievan Rus architecture",
//         "Muscovite architecture",
//         "Imperial Russia architecture",
//         "Soviet Union architecture",
//         "Postwar Soviet architecture",
//         "Modern Russian architecture"
//     ],
//     "pop-culture": [
//         "3DO Interactive Multiplayer",
//         "A Clockwork Orange (1971)",
//         "Adventure Time",
//         "Agent 007",
//         "Ahh! Real Monsters",
//         "Alien (1979)",
//         "Aliens (1986)",
//         "Animaniacs",
//         "Atari",
//         "Attack on Titan",
//         "Batman",
//         "Batman: The Animated Series",
//         "BeastWars",
//         "Beetlejuice",
//         "Ben Hur",
//         "Black Lagoon",
//         "Blade Runner",
//         "Blazing Saddles",
//         "Bleach",
//         "Braveheart (1995)",
//         "Breakfast at Tiffany's",
//         "Call of Duty",
//         "Call of Duty Modern Warfare",
//         "Casablanca",
//         "CatDog",
//         "Chip 'n Dale: Rescue Rangers",
//         "Close Encounters of the Third Kind",
//         "Code Geass",
//         "Comic-Con",
//         "Contact (1997)",
//         "Courage the Cowardly Dog",
//         "Cowboy Bebop",
//         "Danger Mouse",
//         "Dark Souls",
//         "Darkwing Duck",
//         "Death Note",
//         "Demons Souls",
//         "Dexter's Laboratory",
//         "Die Hard",
//         "Digimon",
//         "Dragon Ball",
//         "Dragon Ball GT",
//         "Dragon Ball Super",
//         "Dragon Ball Z",
//         "E.T. the Extra-Terrestrial (1982)",
//         "Earthworm Jim",
//         "Elden Ring",
//         "Ewoks",
//         "FLCL",
//         "Fooly Cooly",
//         "Fortnite",
//         "Full Metal Jacket (1987)",
//         "Fullmetal Alchemist",
//         "Futurama",
//         "Game Boy",
//         "Game Boy Advance",
//         "Game Boy Color",
//         "Game Boy SP",
//         "Gargoyles",
//         "George Lucas",
//         "Ghostbusters",
//         "Goldfinger",
//         "Gone with the Wind (1939)",
//         "Gundam",
//         "He-Man and the Masters of the Universe",
//         "Hellsing",
//         "Inuyasha",
//         "James Bond",
//         "Johnny Bravo",
//         "Jurassic Park",
//         "Jurassic Park III",
//         "Jurassic World",
//         "Jurassic World Dominion",
//         "Jurassic World Fallen Kingdom",
//         "Justice League",
//         "King Kong",
//         "M.A.S.H.",
//         "MASH",
//         "Mad Max",
//         "Mad Max 2: The Road Warrior",
//         "Mad Max Beyond Thunderdome",
//         "Mad Max: Fury Road",
//         "Magic: The Gathering",
//         "MechWarrior",
//         "Mega Man",
//         "Megan Man X",
//         "Metabots",
//         "Michael Crichton",
//         "Mighty Max",
//         "Naruto",
//         "Neon Genesis Evangelion",
//         "Nintendo",
//         "Nintendo 3DS",
//         "Nintendo 64",
//         "Nintendo DS",
//         "Nintendo Entertainment System",
//         "Nintendo Switch",
//         "Nintendo Wii",
//         "Nintendo WiiU",
//         "Overwatch",
//         "PAX",
//         "PC Engine",
//         "Pinky and the Brain",
//         "Planet of the Apes",
//         "Pokemon",
//         "Poltergeist (1982)",
//         "Pulp Fiction",
//         "Raiders of the Lost Ark (1981)",
//         "Rainbow Brite",
//         "ReBoot (1994)",
//         "Regular Show",
//         "Robotech",
//         "Rocko’s Modern Life",
//         "Rugrats",
//         "SEGA",
//         "Samurai Jack",
//         "Scary Stories to Tell in the Dark",
//         "She-Ra: Princess of Power",
//         "Singing in the Rain",
//         "Sony Playstation",
//         "Sony Playstation 2",
//         "Sony Playstation 3",
//         "Sony Playstation 4",
//         "Sony Playstation 5",
//         "Space Dandy",
//         "Spider-Man",
//         "Spiderman",
//         "Star Wars (1977)",
//         "Star Wars: Episode V - The Empire Strikes Back (1980)",
//         "Starcraft",
//         "Steven King",
//         "Steven Spielberg",
//         "Stranger Things",
//         "Street Sharks",
//         "Super Mario Bros.",
//         "Super Nintendo",
//         "Superman",
//         "T-1000",
//         "T-600",
//         "T-800",
//         "TaleSpin",
//         "Teenage Mutant Ninja Turtles",
//         "Terminator 3",
//         "Terminator Dark Fate",
//         "Terminator Genysis",
//         "Terminator Salvation",
//         "The Day the Earth Stood Still",
//         "The Day the Earth Stood Still (1951)",
//         "The Godfather",
//         "The Grim Adventures of Billy and Mandy",
//         "The Hulk",
//         "The Lord of the Rings: The Fellowship of the Ring (2001)",
//         "The Lost World",
//         "The Matrix",
//         "The New Adventures of Johnny Quest",
//         "The Poseidon Adventure (1972)",
//         "The Ren & Stimpy Show",
//         "The Simpsons",
//         "The Terminator",
//         "The Terminator 2: Judgement Day",
//         "The Thing from Another World (1951)",
//         "The Wizard of Oz (1939)",
//         "Thundercats",
//         "Titanic (1997)",
//         "Total Recall",
//         "Toxic Crusaders",
//         "Transformers",
//         "Trigun",
//         "War for the Planet of the Apes",
//         "WarCraft",
//         "Wizard of the Coast",
//         "X-Men",
//         "Xenomorphs",
//         "Yu Yu Hakusho"
//     ],
//     "gen-modifier": [
//         "60s kitsch and psychedelia",
//         "abstract illusionism",
//         "ambrotype",
//         "american romanticism",
//         "anaglyph effect",
//         "anaglyph filter",
//         "blueprint",
//         "brutalism",
//         "chillwave",
//         "cottagecore",
//         "crayon art",
//         "cyanotype",
//         "dark academia",
//         "digital art",
//         "dutch golden age",
//         "fractalism",
//         "fresco",
//         "futuresynth",
//         "german romanticism",
//         "glitch art",
//         "gothic art",
//         "graffiti",
//         "hyperrealism",
//         "infrared",
//         "Lovecraftian",
//         "magic realism",
//         "multiple exposure",
//         "narrative realism",
//         "photorealism",
//         "realism",
//         "retrowave",
//         "Sabattier effect",
//         "Sabattier filter",
//         "still life",
//         "street art",
//         "surrealism",
//         "synthwave",
//         "vaporwave",
//         "afrofuturism",
//         "anime",
//         "avant-garde",
//         "calotype",
//         "camcorder effect",
//         "cubism",
//         "daguerreotype",
//         "doge",
//         "expressionism",
//         "figurativism",
//         "fisheye lens",
//         "gothic",
//         "holography",
//         "impressionism",
//         "inverted colors",
//         "long exposure",
//         "mac and cheese",
//         "macro lens",
//         "manga",
//         "modernism",
//         "naturalism",
//         "optical illusion",
//         "positivism",
//         "stuckism",
//         "symbolism",
//         "telephoto lens",
//         "the matrix",
//         "tilt-shift",
//         "tintype",
//         "tonalism"
//     ],
//     "site": [
//         "trending on ArtStation",
//         "trending on ConceptArtWorld",
//         "trending on Flickr",
//         "trending on Behance",
//         "trending on 500px",
//         "trending on Getty Images",
//         "trending on DeviantArt",
//         "trending on Pixiv",
//         "trending on IllustrationX",
//         "trending on CGSociety",
//         "trending on Unsplash",
//         "trending on Google Images",
//         "trending on Pinterest",
//         "trending on Sketchfab",
//         "trending on Artsy",
//         "National Gallery of Art Highlights",
//         "trending on Saatchi Art"
//     ],
//     lightModifiers: [
//         "Ambient Lighting",
//         "At/During Golden Hour",
//         "Cinematic Lighting",
//         "Golden Hour Sunlight",
//         "Lens Flare",
//         "Studio Lighting",
//         "backlight",
//         "front light",
//         "overcast light",
//         "side-light",
//         "window light"
//     ],
//     styleModifiers: [
//         "acrylic painting",
//         "gouache painting",
//         "Linocut",
//         "made of yarn",
//         "oil painting",
//         "Origami",
//         "pen and ink drawing",
//         "Portrait photograph",
//         "Portrait photograph",
//         "screenshot from Vanity Fair",
//         "screenshot from Vanity Fair",
//         "watercolor painting",
//     ],
//     artInspirations: [
//         "Abstract Expressionism: Jackson Pollock",
//         "Art Nouveau: Alphonse Mucha",
//         "Conceptual Art: Joseph Kosuth",
//         "Cubism: Pablo Picasso",
//         "Dada: Marcel Duchamp",
//         "Expressionism: Vincent Van Gogh",
//         "Fantasy Art: J.R.R Tolkien",
//         "Futurism: Gino Severini",
//         "Hyperrealism: Claudio Bravo",
//         "Impressionism: Claude Monet",
//         "Installation Art: Christo",
//         "Land Art: Robert Smithson",
//         "Minimalism: Donald Judd",
//         "Neo-Expressionism: Georg Baselitz",
//         "Neo-Pop: Jeff Koons",
//         "Op Art: Victor Vasarely",
//         "Performance Art: Marina Abramovic",
//         "Photorealism: Chuck Close",
//         "Pop Art: Andy Warhol",
//         "Realism: Chuck Close",
//         "Surrealism: Salvador Dali",
//     ],
//     photographyInspirations: [
//         "Aerial Photography: Yann Arthus-Bertrand",
//         "Black and White Photography: Robert Capa",
//         "Documentary Photography: Dorothea Lange",
//         // "Sports Photography: David Burnett",
//         "Fashion Photography: Helmut Newton",
//         "Fine Art Photography: Andreas Gursky",
//         "Food Photography: David LaChapelle",
//         "Landscape Photography: Ansel Adams",
//         "Macro Photography: Art Wolfe",
//         "Nature Photography: Frans Lanting",
//         "Portrait Photography: Annie Leibovitz",
//         "Still Life Photography: Irving Penn",
//         "Street Photography: Henri Cartier-Bresson",
//         "Travel Photography: Steve McCurry",
//         "Underwater Photography: David Doubilet",
//         "Wildlife Photography: Steve McCurry",
//         // "Astrophotography: Michael Benson",
//         // "Time-Lapse Photography: Tom Lowe",
//         // "Infrared Photography: Michael Kenna",
//         // "Tilt-Shift Photography: Ben Thomas"
//     ],
//     // artStyles: {
//     //     "Abstract Expressionism": [
//     //         "Jackson Pollock",
//     //         "Mark Rothko"
//     //     ],
//     //     "Art Nouveau": [
//     //         "Alphonse Mucha",
//     //         "Gustav Klimt"
//     //     ],
//     //     "Conceptual Art": [
//     //         "Joseph Kosuth",
//     //         "Sol LeWitt"
//     //     ],
//     //     "Cubism": [
//     //         "Pablo Picasso",
//     //         "Georges Braque"
//     //     ],
//     //     "Dada": [
//     //         "Marcel Duchamp",
//     //         "Hannah Hoch"
//     //     ],
//     //     "Expressionism": [
//     //         "Vincent Van Gogh",
//     //         "Edvard Munch"
//     //     ],
//     //     "Fantasy Art": [
//     //         "J.R.R Tolkien",
//     //         "Brian Froud"
//     //     ],
//     //     "Futurism": [
//     //         "Gino Severini",
//     //         "H.R Giger"
//     //     ],
//     //     "Hyperrealism": [
//     //         "Claudio Bravo",
//     //         "John Baeder"
//     //     ],
//     //     "Impressionism": [
//     //         "Claude Monet",
//     //         "Pierre-Auguste Renoir"
//     //     ],
//     //     "Installation Art": [
//     //         "Christo",
//     //         "Jeanne-Claude"
//     //     ],
//     //     "Land Art": [
//     //         "Robert Smithson",
//     //         "Michael Heizer"
//     //     ],
//     //     "Minimalism": [
//     //         "Donald Judd",
//     //         "Agnes Martin"
//     //     ],
//     //     "Neo-Expressionism": [
//     //         "Georg Baselitz",
//     //         "Anselm Kiefer"
//     //     ],
//     //     "Neo-Pop": [
//     //         "Jeff Koons",
//     //         "Damien Hirst"],
//     //     "Op Art": [
//     //         "Victor Vasarely",
//     //         "Bridget Riley"
//     //     ],
//     //     "Performance Art": [
//     //         "Marina Abramovic",
//     //         "Yoko Ono"
//     //     ],
//     //     "Photorealism": [
//     //         "Chuck Close",
//     //         "Richard Estes"
//     //     ],
//     //     "Pop Art": [
//     //         "Andy Warhol",
//     //         "Roy Lichtenstein"
//     //     ],
//     //     "Realism": [
//     //         "Chuck Close",
//     //         "Richard Estes"
//     //     ],
//     //     "Surrealism": [
//     //         "Salvador Dali",
//     //         "Max Ernst",
//     //         "M.C Escher"
//     //     ],
//     // },
//     promptModifiers: [
//         "3D rendering",
//         "4k/8k",
//         "Award-Winning Art",
//         "character design",
//         "concept art",
//         "digital painting",
//         "photo-manipulation",
//         "photorealistic",
//         "trending on Artstation",
//         "ultrarealistic editorial photograph",
//         "unreal engine",
//     ],
//     stylized: [
//         "Vibrant, abstract, with bold shapes and lines and high resolution",
//         "Futuristic, sleek, with metallic surfaces, neon lighting and sharp focus",
//         "Ethereal, dreamlike, with soft focus and misty landscapes, and sharp details"
//     ],
//     // "artist-surreal": [
//     //     "Art et Liberte",
//     //     "Aase Berg",
//     //     "Yutaka Bito",
//     //     "Bodo",
//     //     "Victor Brauner",
//     //     "Emmy Bridgwater",
//     //     "Robert Campbell ",
//     //     "Giorgio de Chirico",
//     //     "William Copley ",
//     //     "Joao Artur da Silva",
//     //     "Elba Damast",
//     //     "Paul Delvaux",
//     //     "Karina Eibatova",
//     //     "Harold Elliott",
//     //     "Max Ernst",
//     //     "Ewa Juszkiewicz",
//     //     "Agustin Fernandez ",
//     //     "Ichiro Fukuzawa",
//     //     "Abdel Hadi Al Gazzar",
//     //     "Emma Geary",
//     //     "Alberto Giacometti",
//     //     "Arshile Gorky",
//     //     "Jane Graverol",
//     //     "Henriette Grindat",
//     //     "Moosa Al Halyan",
//     //     "Irene Hamoir",
//     //     "Gilberto Hernandez Ortega",
//     //     "Kati Horna",
//     //     "Tetsuya Ishida",
//     //     "Alpo Jaakola",
//     //     "Frida Kahlo",
//     //     "Ida Kar",
//     //     "Yuki Katsura",
//     //     "Hiroshi Katsuragawa",
//     //     "Rita Kernn-Larsen",
//     //     "Greta Knutson",
//     //     "Harue Koga",
//     //     "Wifredo Lam",
//     //     "Rene Magritte",
//     //     "Joyce Mansour",
//     //     "Roberto Matta",
//     //     "Lise Mayer",
//     //     "Emila Medkova",
//     //     "Ahmed Morsi",
//     //     "Polly Nor",
//     //     "Meret Oppenheim",
//     //     "Olga Orozco",
//     //     "Kiyoji Otsuji",
//     //     "Wolfgang Paalen",
//     //     "Ihor Podolchak",
//     //     "Joyce Reopel",
//     //     "Aminollah Rezaei",
//     //     "Guia Risari",
//     //     "Erna Rosenstein",
//     //     "Pablo Runyan",
//     //     "Xanti Schawinsky",
//     //     "Eva Svankmajerova",
//     //     "Alina Szapocznikow",
//     //     "Enrique Tabara",
//     //     "Dorothea Tanning",
//     //     "Herve Telemaque",
//     //     "Blanca Varela",
//     //     "Rinat Voligamsi",
//     //     "Kikuji Yamashita",
//     //     "Ramses Younan",
//     //     "Haifa Zangana",
//     //     "Nele Zirnite",
//     //     "Unica Zurn"
//     // ],
//     // "games": [
//     //     "8-bit JRPG",
//     //     "A Short Hike",
//     //     "Age of Empires",
//     //     "Albion",
//     //     "Alone in the Dark",
//     //     "Angry Birds",
//     //     "Animal Crossing",
//     //     "Baldur's Gate II",
//     //     "Baldurs Gate",
//     //     "Bastion",
//     //     "Battle Axe",
//     //     "BioShock",
//     //     "Blizzard",
//     //     "Cadillacs and Dinosaurs",
//     //     "Candy Crush",
//     //     "Carmen Sandiego",
//     //     "Castle Wolfenstein",
//     //     "Castlevania",
//     //     "Chrono Trigger",
//     //     "Civilization V",
//     //     "Command & Conquer Red Alert",
//     //     "Commander Keen",
//     //     "Crusaider No Regret",
//     //     "Dark Souls",
//     //     "Darkest Dungeon",
//     //     "Day of the Tentacle",
//     //     "Desert Strike",
//     //     "Diablo 2",
//     //     "Diablo",
//     //     "Disco Elysium",
//     //     "Discworld",
//     //     "Divinity Original Sin",
//     //     "Doom",
//     //     "Dota 2",
//     //     "Dune",
//     //     "Escape from Monkey Island",
//     //     "Factorio",
//     //     "Fall out",
//     //     "Final Fantasy",
//     //     "Full Throttle",
//     //     "Full Throttle",
//     //     "Game Boy Advance",
//     //     "Game Boy Color",
//     //     "Game Boy",
//     //     "God of War",
//     //     "Grand Theft Auto III",
//     //     "Grim dawn",
//     //     "Grim Fandango",
//     //     "GTA 1",
//     //     "GTA 2",
//     //     "GTA V",
//     //     "Half-Life",
//     //     "Harvest Moon",
//     //     "I Have No Mouth And I Must Scream",
//     //     "Indiana Jones and the Fate of Atlantis",
//     //     "JRPG",
//     //     "League of Legends",
//     //     "Legend of Mana",
//     //     "Leisure Suit Larry",
//     //     "Lemmings",
//     //     "Little Big Adventure",
//     //     "Loom",
//     //     "LucasArts adventure games",
//     //     "LucasArts",
//     //     "Magic Carpet",
//     //     "Maniac Mansion",
//     //     "Mario Galaxy",
//     //     "Mario Odissey",
//     //     "Marvel vs. Capcom",
//     //     "MDK",
//     //     "Metal Slug",
//     //     "Metroid Prime",
//     //     "Minecraft",
//     //     "Monster Rancher",
//     //     "Monument Valley",
//     //     "Mortal Kombat",
//     //     "Myst",
//     //     "Neverwinter Nights",
//     //     "Nintendo DS",
//     //     "Nintendo N64",
//     //     "Nintendo",
//     //     "Overwatch",
//     //     "Path of Exile",
//     //     "Plants vs zombies",
//     //     "Playstation 1",
//     //     "Playstation 2",
//     //     "Pokemon",
//     //     "Portal 2",
//     //     "Prince of Persia",
//     //     "Priston Tale",
//     //     "PS One",
//     //     "Quake",
//     //     "Ragnarok",
//     //     "Raptor Call of the Shadows",
//     //     "Red Dead Redemption 2",
//     //     "Redneck Rampage",
//     //     "Resident Evil",
//     //     "Retro RPG",
//     //     "Rimworld",
//     //     "Rockstar Games",
//     //     "Roler Coaster Tycoon",
//     //     "Runescape",
//     //     "Sam & Max Hit the Road",
//     //     "Samorost",
//     //     "ScummVM",
//     //     "Shadowrun",
//     //     "Sid Meier’s Civilization",
//     //     "Simant",
//     //     "Simcity 2000",
//     //     "Simcity 3000",
//     //     "Simon the Sorcerer",
//     //     "Skyrim",
//     //     "Sony",
//     //     "Square Enix",
//     //     "Star wars KOTOR",
//     //     "Star wars yoda stories",
//     //     "Starcraft",
//     //     "Stardew Valley",
//     //     "Starfox",
//     //     "Street Fighter",
//     //     "Super Mario Bros 3",
//     //     "Super Mario RPG",
//     //     "Super Mario World",
//     //     "Super Metroid",
//     //     "Super Nintendo",
//     //     "Superfrog",
//     //     "Syndicate",
//     //     "Team Fortress 2",
//     //     "Tetris",
//     //     "The Chaos Engine",
//     //     "The Dig",
//     //     "The Elder Scrolls",
//     //     "The Elder Scrolls",
//     //     "The Incredible Machine",
//     //     "The Journey Down",
//     //     "The Last of Us",
//     //     "The Legend of Zelda",
//     //     "The Lord of the Rings",
//     //     "The Secret of Monkey Island",
//     //     "The Witcher",
//     //     "Theme Park",
//     //     "Thief",
//     //     "Tibia",
//     //     "Tomb Raider",
//     //     "Tony Hawk's Pro Skater 2",
//     //     "Transport Tycoon",
//     //     "Tropico 5",
//     //     "Tyrian",
//     //     "Ultima Online",
//     //     "Undertale",
//     //     "Warcraft",
//     //     "Wing Commander",
//     //     "World of Warcraft",
//     //     "X-Com UFO Defense",
//     //     "X-men",
//     //     "Yoshi's Island",
//     //     "Zak McKracken and the Alien Mindbenders"
//     // ],
//     artStylesArray: [
//         "Abstract Expressionism, with a focus on non-representational forms, gestural brushstrokes, and the artist's emotions, inspired by Jackson Pollock and Mark Rothko",
//         "Art Brut, with a focus on raw, untrained, and intuitive art, inspired by Jean Dubuffet and Henry Darger",
//         "Art Deco, with a focus on geometric shapes, bold colors, and luxury, inspired by Erte and Tamara de Lempicka",
//         "Art Nouveau, with a focus on organic shapes, asymmetry, and ornate decoration, inspired by Alphonse Mucha and Gustav Klimt",
//         "Cubism, with a focus on geometric shapes, multiple perspectives, and collage, inspired by Pablo Picasso and Georges Braque",
//         "Dada, with a focus on randomness, nonsense, and anti-art sentiments, inspired by Marcel Duchamp and Hannah Höch",
//         "Expressionism, with a focus on bold colors, brushstrokes, and emotions, inspired by Vincent Van Gogh and Edvard Munch",
//         "Fantasy Art, with a focus on vivid colors, whimsical imagery, and fantastical elements, inspired by J.R.R Tolkien and Brian Froud",
//         "Futurism, with a focus on sleek and metallic surfaces, industrial landscapes, and technology, inspired by Gino Severini and H.R Giger",
//         "Hyperrealism, with a focus on photorealistic details, textures, and accuracy, inspired by Richard Estes and Denis Peterson",
//         "Impressionism, with a focus on light, movement, and color, inspired by Claude Monet and Pierre-Auguste Renoir",
//         "Minimalism, with a focus on simplicity, negative space, and geometric shapes, inspired by Donald Judd and Agnes Martin",
//         "Neo-Expressionism, with a focus on intense colors, gestural brushstrokes, and raw emotions, inspired by Jean-Michel Basquiat and Julian Schnabel",
//         "Op Art, with a focus on optical illusions, geometric shapes, and the interaction of light and color, inspired by Victor Vasarely and Bridget Riley",
//         "Pointillism, with a focus on small, distinct dots of color, and optical mixing, inspired by Georges Seurat and Paul Signac",
//         "Pop Art, with a focus on popular culture, consumerism, and irony, inspired by Andy Warhol and Roy Lichtenstein",
//         "Post-Impressionism, with a focus on emotional and symbolic content, vibrant colors, and thick paint, inspired by Paul Cezanne and Vincent van Gogh",
//         "Realism, with a focus on photorealistic details, textures, and accuracy, inspired by Chuck Close and Richard Estes",
//         "Rococo, with a focus on ornate and frivolous decoration, asymmetry, and pastel colors, inspired by Fragonard and Jean-Honoré Fragonard",
//         "Surrealism, with a focus on disorienting perspectives, abstract shapes, and impossible constructions, inspired by M.C Escher and Salvador Dali",
//         "Surrealism, with a focus on dreamlike landscapes, abstract shapes, and a juxtaposition of elements, inspired by Salvador Dali and Max Ernst",
//     ],
//     lightingStyles,
// };

let lightModifiers = ["Cinematic Lighting", "Studio Lighting", "window light", "Golden Hour Sunlight", "Ambient Lighting", "backlight", "side-light", "Lens Flare", "front light", "overcast light"];

let colorTones = [
    {
        "name": "Vintage",
        "keywords": ["old", "nostalgic", "retro", "warm", "sepia"],
        "details": ["uses warm tones and a sepia effect to create a vintage look", "emulates the aesthetic of old photographs"]
    },
    {
        "name": "Black and White",
        "keywords": ["classic", "elegant", "minimal", "black and white", "grayscale"],
        "details": ["uses a black and white or grayscale effect", "creates a classic and elegant look"]
    },
    {
        "name": "Cinematic",
        "keywords": ["dramatic", "moody", "intense", "film", "color grading"],
        "details": ["uses color grading techniques to emulate the aesthetic of film", "creates a dramatic and moody look"]
    },
    {
        "name": "Pastel",
        "keywords": ["soft", "feminine", "romantic", "pastel", "color grading"],
        "details": ["uses color grading techniques to create pastel tones", "creates a soft and feminine look"]
    },
    {
        "name": "Matte",
        "keywords": ["muted", "subtle", "minimal", "matte", "color grading"],
        "details": ["uses color grading techniques to create a matte effect", "creates a muted and subtle look"]
    },
    {
        "name": "Cross Process",
        "keywords": ["vibrant", "edgy", "experimental", "cross process", "color grading"],
        "details": ["uses color grading techniques to emulate the effect of cross processing film", "creates a vibrant and edgy look"]
    },
    {
        "name": "HDR",
        "keywords": ["dramatic", "moody", "intense", "HDR", "color grading"],
        "details": ["uses color grading techniques to create a High Dynamic Range effect", "creates a dramatic and intense look"]
    },
    {
        "name": "Lomography",
        "keywords": ["fun", "quirky", "experimental", "lomo", "color grading"],
        "details": ["uses color grading techniques to emulate the aesthetic of Lomography film", "creates a fun and quirky look"]
    },
    {
        "name": "Faded",
        "keywords": ["vintage", "nostalgic", "subtle", "faded", "color grading"],
        "details": ["uses color grading techniques to create a faded effect", "creates a vintage and nostalgic look"]
    },
    {
        "name": "Surreal",
        "keywords": ["otherworldly", "ethereal", "unreal", "surreal", "color grading"],
        "details": ["uses color grading techniques to create a surreal effect", "creates an otherworldly and ethereal look"]
    },
    {
        "name": "Retro futuristic",
        "keywords": ["futuristic", "retro", "unconventional", "retro futuristic", "color grading"],
        "details": ["uses color grading techniques to create a retro futuristic effect", "creates a futuristic and unconventional look"]
    }
];
let movieTones = [
    {
        "name": "Warm",
        "keywords": ["warm", "intimate", "emotional", "golden hour", "color grading"],
        "details": ["uses color grading techniques to emulate the warm tones of golden hour lighting", "creates an intimate and emotional atmosphere"]
    },
    {
        "name": "Cold",
        "keywords": ["cold", "detached", "clinical", "blue", "color grading"],
        "details": ["uses color grading techniques to create a cold blue tone", "creates a detached and clinical atmosphere"]
    },
    {
        "name": "Vibrant",
        "keywords": ["vibrant", "energetic", "lively", "saturation", "color grading"],
        "details": ["uses color grading techniques to increase saturation", "creates a vibrant and energetic atmosphere"]
    },
    {
        "name": "Desaturated",
        "keywords": ["muted", "subtle", "minimal", "desaturation", "color grading"],
        "details": ["uses color grading techniques to decrease saturation", "creates a muted and subtle atmosphere"]
    },
    {
        "name": "High Contrast",
        "keywords": ["dramatic", "intense", "bold", "high contrast", "color grading"],
        "details": ["uses color grading techniques to increase contrast", "creates a dramatic and intense atmosphere"]
    },
    {
        "name": "Low Contrast",
        "keywords": ["soft", "muted", "subtle", "low contrast", "color grading"],
        "details": ["uses color grading techniques to decrease contrast", "creates a soft and muted atmosphere"]
    },
    {
        "name": "Washed Out",
        "keywords": ["faded", "vintage", "nostalgic", "washed out", "color grading"],
        "details": ["uses color grading techniques to create a washed out effect", "creates a faded and vintage atmosphere"]
    },
    {
        "name": "Split Toning",
        "keywords": ["dramatic", "moody", "intense", "split toning", "color grading"],
        "details": ["uses color grading techniques to create a split toning effect", "creates a dramatic and moody atmosphere"]
    },
    {
        "name": "Noir",
        "keywords": ["dark", "mysterious", "intense", "noir", "color grading"],
        "details": ["uses color grading techniques to emulate the aesthetic of film noir", "creates a dark and mysterious atmosphere"]
    },
    {
        "name": "Dreamy",
        "keywords": ["ethereal", "surreal", "otherworldly", "dreamy", "color grading"],
        "details": ["uses color grading techniques to create a dreamy effect", "creates an ethereal and surreal atmosphere"]
    },
    {
        "name": "Neon",
        "keywords": ["vibrant", "futuristic", "unconventional", "neon", "color grading"],
        "details": ["uses color grading techniques to create a neon effect", "creates a vibrant and futuristic atmosphere"]
    },
    {
        "name": "Bleach Bypass",
        "keywords": ["gritty", "urban", "realistic", "bleach bypass", "color grading"],
        "details": ["uses color grading techniques to create a bleach bypass effect", "creates a gritty and urban atmosphere"]
    },
    {
        "name": "Foggy",
        "keywords": ["misty", "hazy", "subtle", "foggy", "color grading"],
        "details": ["uses color grading techniques to create a foggy effect", "creates a misty and hazy atmosphere"]
    },
    {
        "name": "Gritty",
        "keywords": ["gritty", "urban", "realistic", "gritty", "color grading"],
        "details": ["uses color grading techniques to create a gritty effect", "creates a gritty and urban atmosphere"]
    },
    {
        "name": "Dramatic",
        "keywords": ["dramatic", "intense", "bold", "dramatic", "color grading"],
        "details": ["uses color grading techniques to create a dramatic effect", "creates a dramatic and intense atmosphere"]
    },
    {
        "name": "Surreal",
        "keywords": ["surreal", "otherworldly", "ethereal", "surreal", "color grading"],
        "details": ["uses color grading techniques to create a surreal effect", "creates an otherworldly and ethereal atmosphere"]
    },
    {
        "name": "Retro futuristic",
        "keywords": ["futuristic", "retro", "unconventional", "retro futuristic", "color grading"],
        "details": ["uses color grading techniques to create a retro futuristic effect", "creates a futuristic and unconventional atmosphere"]
    },
];
let colorSchemes = [
    {
        "name": "Warm",
        "keywords": ["warm", "golden", "emotional", "color scheme"],
        "details": ["uses warm colors such as gold, yellow, orange, and red", "creates an emotional and intimate atmosphere"]
    },
    {
        "name": "Cool",
        "keywords": ["cool", "blue", "detached", "color scheme"],
        "details": ["uses cool colors such as blue, purple, and green", "creates a detached and clinical atmosphere"]
    },
    {
        "name": "Monochromatic",
        "keywords": ["monochromatic", "subtle", "minimal", "color scheme"],
        "details": ["uses a single color or shades of the same color", "creates a subtle and minimal atmosphere"]
    },
    {
        "name": "Complementary",
        "keywords": ["complementary", "vibrant", "lively", "color scheme"],
        "details": ["uses colors that are opposite each other on the color wheel", "creates a vibrant and lively atmosphere"]
    },
    {
        "name": "Analogous",
        "keywords": ["analogous", "muted", "subtle", "color scheme"],
        "details": ["uses colors that are next to each other on the color wheel", "creates a muted and subtle atmosphere"]
    },
    {
        "name": "Split Complementary",
        "keywords": ["split complementary", "dramatic", "intense", "color scheme"],
        "details": ["uses a base color and the two colors on either side of its complement", "creates a dramatic and intense atmosphere"]
    },
    {
        "name": "Triadic",
        "keywords": ["triadic", "balanced", "harmonious", "color scheme"],
        "details": ["uses three colors that are evenly spaced around the color wheel", "creates a balanced and harmonious atmosphere"]
    },
    {
        "name": "Tetradic",
        "keywords": ["tetradic", "complex", "experimental", "color scheme"],
        "details": ["uses four colors arranged into two complementary pairs", "creates a complex and experimental atmosphere"]
    },
    {
        "name": "Square",
        "keywords": ["square", "dynamic", "intense", "color scheme"],
        "details": ["uses four colors arranged into a rectangle", "creates a dynamic and intense atmosphere"]
    },
    {
        "name": "Natural",
        "keywords": ["natural", "realistic", "believable", "color scheme"],
        "details": ["uses colors found in nature such as greens, browns, and blues", "creates a realistic and believable atmosphere"]
    }
];
// let styleModifiers = ["Portrait photograph", "gouache painting", "screenshot from Vanity Fair"];

let lightingStyles = {
    naturalLight: {
        name: "Natural Light",
        styles: [
            {
                "name": "Golden Hour",
                "keywords": ["warm", "soft", "glow", "sun", "diffused"],
                "details": ["uses the warm light during sunrise or sunset", "creates a soft and warm atmosphere", "emphasizes the natural golden hour glow", "Soft shadows"]
            },
            {
                "name": "Overcast",
                "keywords": ["soft", "diffused", "even", "cloudy", "ambient"],
                "details": ["uses the light on cloudy days", "creates a soft and even atmosphere", "emphasizes the diffused light", "Soft shadows"]
            },
            {
                "name": "Bright Sunlight",
                "keywords": ["harsh", "strong", "contrasty", "sun", "direct"],
                "details": ["uses the strong and harsh light of the sun", "creates a contrasty and intense atmosphere", "emphasizes the direct sunlight", "Hard shadows"]
            },
            {
                "name": "Backlit",
                "keywords": ["silhouette", "dramatic", "mysterious", "sun", "backlight"],
                "details": ["uses the backlight of the sun", "creates a silhouette and dramatic atmosphere", "emphasizes the mysterious and intriguing shadows", "Hard shadows"]
            },
            {
                "name": "Open Shade",
                "keywords": ["soft", "diffused", "cool", "shaded", "ambient"],
                "details": ["uses the light in shaded areas", "creates a soft and cool atmosphere", "emphasizes the diffused light", "Soft shadows"]
            },
            {
                "name": "Partly Cloudy",
                "keywords": ["varied", "interesting", "dynamic", "cloudy", "ambient"],
                "details": ["uses the light on partly cloudy days", "creates a varied and dynamic atmosphere", "emphasizes the interesting shadows", "Varied shadows"]
            },
            {
                "name": "Hazy",
                "keywords": ["soft", "atmospheric", "mysterious", "haze", "ambient"],
                "details": ["uses the light on hazy days", "creates a soft and atmospheric atmosphere", "emphasizes the mysterious shadows", "Soft shadows"]
            },
            {
                "name": "Rainy",
                "keywords": ["glossy", "moody", "romantic", "rain", "ambient"],
                "details": ["uses the light on rainy days", "creates a glossy and moody atmosphere", "emphasizes the romantic and intimate shadows", "Soft shadows"]
            },
            {
                "name": "Snowy",
                "keywords": ["bright", "soft", "cool", "snow", "ambient"],
                "details": ["uses the light on snowy days", "creates a bright and cool atmosphere", "emphasizes the soft and delicate shadows", "Soft shadows"]
            },
            {
                "name": "Foggy",
                "keywords": ["mysterious", "atmospheric", "eerie", "fog", "ambient"],
                "details": ["uses the light on foggy days", "creates a mysterious and eerie atmosphere", "emphasizes the atmospheric and natural shadows", "Soft shadows"]
            },
        ]
    },
    studioLighting: {
        name: "Studio Lighting",
        styles: [
            {
                "name": "Rembrandt",
                "keywords": ["dramatic", "moody", "artistic", "softbox", "key light"],
                "details": ["uses a key light with a softbox and a fill light", "creates a dramatic and moody atmosphere", "emphasizes the Rembrandt triangle on the face"]
            },
            {
                "name": "Butterfly",
                "keywords": ["glamorous", "feminine", "romantic", "beauty dish", "key light"],
                "details": ["uses a key light with a beauty dish and a fill light", "creates a glamorous and feminine atmosphere", "emphasizes the butterfly pattern on the face"]
            },
            {
                "name": "Loop",
                "keywords": ["professional", "classic", "formal", "umbrella", "key light"],
                "details": ["uses a key light with an umbrella and a fill light", "creates a professional and classic atmosphere", "emphasizes the loop pattern on the face"]
            },
            {
                "name": "Split",
                "keywords": ["dramatic", "moody", "intense", "spotlight", "key light"],
                "details": ["uses a key light with a spotlight and a fill light", "creates a dramatic and intense atmosphere", "emphasizes the split lighting pattern on the face"]
            },
            {
                "name": "Flat",
                "keywords": ["simple", "minimal", "clean", "softbox", "key light"],
                "details": ["uses a key light with a softbox and a fill light", "creates a simple and minimal atmosphere", "emphasizes the flat lighting pattern on the face"]
            },
            {
                "name": "Short",
                "keywords": ["dramatic", "moody", "intense", "beauty dish", "key light"],
                "details": ["uses a key light with a beauty dish and a fill light", "creates a dramatic and intense atmosphere", "emphasizes the short lighting pattern on the face"]
            },
            {
                "name": "Broad",
                "keywords": ["soft", "feminine", "romantic", "umbrella", "key light"],
                "details": ["uses a key light with an umbrella and a fill light", "creates a soft and feminine atmosphere", "emphasizes the broad lighting pattern on the face"]
            },
            {
                "name": "Low Key",
                "keywords": ["dark", "mysterious", "intense", "spotlight", "key light"],
                "details": ["uses a key light with a spotlight and minimal fill light", "creates a dark and mysterious atmosphere", "emphasizes the low key lighting pattern on the face"]
            },
            {
                "name": "High Key",
                "keywords": ["bright", "clean", "minimal", "softbox", "key light"],
                "details": ["uses a key light with a softbox and lots of fill light", "creates a bright and clean atmosphere", "emphasizes the high key lighting pattern on the face"]
            },
            {
                "name": "Edge",
                "keywords": ["dramatic", "moody", "edgy", "snoot", "key light"],
                "details": ["uses a key light with a snoot and a fill light", "creates a dramatic and edgy atmosphere", "emphasizes the edge lighting pattern on the face"]
            }
        ]
    },
    creativeLighting: {
        name: "Creative Lighting",
        styles: [
            {
                "name": "Rainbow",
                "keywords": ["colorful", "fun", "creative", "gels", "key light"],
                "details": ["uses colored gels on the key light to create a rainbow effect", "creates a colorful and fun atmosphere"]
            },
            {
                "name": "Neon",
                "keywords": ["vibrant", "edgy", "modern", "neon light", "key light"],
                "details": ["uses neon lights as the key light", "creates a vibrant and edgy atmosphere"]
            },
            {
                "name": "Fairy",
                "keywords": ["soft", "delicate", "ethereal", "fairy lights", "ambient"],
                "details": ["uses fairy lights as the ambient light", "creates a soft and delicate atmosphere"]
            },
            {
                "name": "Fire",
                "keywords": ["warm", "intense", "dramatic", "flame", "ambient"],
                "details": ["uses flames as the ambient light", "creates a warm and intense atmosphere"]
            },
            {
                "name": "Laser",
                "keywords": ["dramatic", "futuristic", "edgy", "laser", "key light"],
                "details": ["uses laser lights as the key light", "creates a dramatic and futuristic atmosphere"]
            },
            {
                "name": "Glow",
                "keywords": ["ethereal", "mysterious", "enigmatic", "glow sticks", "ambient"],
                "details": ["uses glow sticks as the ambient light", "creates an ethereal and mysterious atmosphere"]
            },
            {
                "name": "Ice",
                "keywords": ["cool", "icy", "serene", "frost", "ambient"],
                "details": ["uses frost as the ambient light", "creates a cool and icy atmosphere"]
            },
            {
                "name": "Cinematic",
                "keywords": ["dramatic", "moody", "intense", "film light", "key light"],
                "details": ["uses film lights as the key light", "creates a dramatic and moody atmosphere"]
            },
            {
                "name": "Candle",
                "keywords": ["warm", "romantic", "intimate", "candle", "ambient"],
                "details": ["uses candles as the ambient light", "creates a warm and romantic atmosphere"]
            },
            {
                "name": "Candlelight",
                "keywords": ["romantic", "intimate", "soft", "candle", "ambient"],
                "details": ["uses candles as the ambient light", "creates a romantic and intimate atmosphere"]
            },
            {
                "name": "Glowstick",
                "keywords": ["bright", "vibrant", "fun", "glow sticks", "ambient"],
                "details": ["uses glow sticks as the ambient light", "creates a bright and vibrant atmosphere"]
            },
            {
                "name": "Strobe",
                "keywords": ["dramatic", "edgy", "intense", "strobe light", "key light"],
                "details": ["uses strobe lights as the key light", "creates a dramatic and intense atmosphere"]
            },
            {
                "name": "Starlight",
                "keywords": ["serene", "peaceful", "calm", "starlight", "ambient"],
                "details": ["uses starlight as the ambient light", "creates a serene and peaceful atmosphere"]
            }
        ]
    },
    moodLighting: {
        name: "Mood Lighting",
        styles: [
            {
                "name": "Shadowy",
                "keywords": ["dark", "mysterious", "enigmatic", "dramatic", "flash", "shaded"],
                "details": ["uses a flash light to create shadows", "creates a dark and mysterious atmosphere"]
            },
            {
                "name": "Natural",
                "keywords": ["realistic", "available light", "outdoor", "indoor", "sun", "diffused"],
                "details": ["uses natural light", "creates a realistic and natural atmosphere"]
            },
            {
                "name": "Candid",
                "keywords": ["natural", "spontaneous", "unposed", "available light", "ambient"],
                "details": ["uses natural light", "creates a natural and spontaneous atmosphere"]
            },
            {
                "name": "Artificial",
                "keywords": ["flash", "studio", "controlled", "color temperature", "tungsten", "strobe"],
                "details": ["uses artificial light", "creates a controlled and artificial atmosphere"]
            },
            {
                "name": "High Key",
                "keywords": ["bright", "light tones", "soft", "softbox", "diffused"],
                "details": ["uses a softbox to create soft light", "creates a bright and light atmosphere"]
            },
            {
                "name": "Minimalistic",
                "keywords": ["minimal", "simple", "clean", "reflective", "shaded"],
                "details": ["uses reflective surfaces to create shadows", "creates a minimal and simple atmosphere"]
            },
            {
                "name": "Serene",
                "keywords": ["calm", "tranquil", "serene", "diffused", "ambient"],
                "details": ["uses diffused light", "creates a calm and tranquil atmosphere"]
            },
            {
                "name": "Vibrant",
                "keywords": ["colorful", "lively", "energetic", "colored", "stobe"],
                "details": ["uses colored lights", "creates a colorful and energetic atmosphere"]
            },
            {
                "name": "Ethereal",
                "keywords": ["ethereal", "otherworldly", "surreal", "ambient", "diffused"],
                "details": ["uses diffused light", "creates an ethereal and otherworldly atmosphere"]
            },
            {
                "name": "Romantic",
                "keywords": ["romantic", "intimate", "sentimental", "diffused", "ambient"],
                "details": ["uses diffused light", "creates a romantic and intimate atmosphere"]
            },
            {
                "name": "Fantasy",
                "keywords": ["fantasy", "otherworldly", "surreal", "colored", "ambient"],
                "details": ["uses colored lights", "creates a fantasy and otherworldly atmosphere"]
            },
            {
                "name": "Gothic",
                "keywords": ["gothic", "dramatic", "mysterious", "shadowy", "ambient"],
                "details": ["uses ambient light", "creates a gothic and dramatic atmosphere"]
            },
            {
                "name": "Historical",
                "keywords": ["historical", "authentic", "old-fashioned", "ambient", "reflective"],
                "details": ["uses ambient light", "creates a historical and authentic atmosphere"]
            },
            {
                "name": "Contemporary",
                "keywords": ["contemporary", "modern", "edgy", "colored", "strobe"],
                "details": ["uses colored lights", "creates a contemporary and modern atmosphere"]
            },
            {
                "name": "Elegant",
                "keywords": ["elegant", "refined", "luxurious", "softbox", "diffused"],
                "details": ["uses a soft box to create soft light", "creates an elegant and refined atmosphere"]
            },
            {
                "name": "Industrial",
                "keywords": ["industrial", "gritty", "urban", "shaded", "flash"],
                "details": ["uses a flash light to create shadows", "creates an industrial and gritty atmosphere"]
            },
            {
                "name": "Surreal",
                "keywords": ["surreal", "dreamlike", "abstract", "colored", "ambient"],
                "details": ["uses colored lights", "creates a surreal and dreamlike atmosphere"]
            },
            {
                "name": "Cinematic",
                "keywords": ["cinematic", "movie-like", "dramatic", "artificial", "spotlight"],
                "details": ["uses a spotlight to create dramatic light", "creates a cinematic and movie-like atmosphere"]
            },
            {
                "name": "Fashion",
                "keywords": ["fashion", "glamorous", "stylized", "colored", "strobe"],
                "details": ["uses colored lights", "creates a fashion and glamorous atmosphere"]
            },
            {
                "name": "Glamour",
                "keywords": ["glamour", "luxurious", "glossy", "softbox", "diffused"],
                "details": ["uses a soft box to create soft light", "creates a glamour and luxurious atmosphere"]
            },
            {
                "name": "Subtle",
                "keywords": ["subtle", "delicate", "tasteful", "ambient", "diffused"],
                "details": ["uses diffused light", "creates a subtle and delicate atmosphere"]
            },
            {
                "name": "Playful",
                "keywords": ["playful", "lighthearted", "fun", "colored", "ambient"],
                "details": ["uses colored lights", "creates a playful and lighthearted atmosphere"]
            },
            {
                "name": "Somber",
                "keywords": ["somber", "solemn", "mournful", "shaded", "ambient"],
                "details": ["uses ambient light", "creates a somber and solemn atmosphere"]
            },
            {
                "name": "Enigmatic",
                "keywords": ["enigmatic", "mysterious", "cryptic", "shadowy", "ambient"],
                "details": ["uses ambient light", "creates an enigmatic and mysterious atmosphere"]
            },
            {
                "name": "Futuristic",
                "keywords": ["futuristic", "innovative", "high-tech", "colored", "artificial"],
                "details": ["uses colored lights", "creates a futuristic and innovative atmosphere"]
            },
            {
                "name": "Low Key",
                "keywords": ["dark tones", "minimal highlights", "moody", "dramatic", "shadowy", "flash", "shaded"]
            },
            {
                "name": "Dramatic",
                "keywords": ["high contrast", "strong shadows", "emotional", "intense", "sun", "backlight", "spotlight"],
                "details": ["uses a spotlight to create dramatic light", "creates a dramatic and emotional atmosphere"]
            },
            {
                "name": "Moody",
                "keywords": ["atmospheric", "evocative", "melancholic", "mysterious", "ambient", "diffused", "colored"],
                "details": ["uses diffused light", "creates a moody and atmospheric atmosphere"]
            },
        ]
    }
};
let imageStaging = {
    outdoorStyles: {
        name: "Outdoor Advanced",
        styles: [
            {
                "name": "City",
                "keywords": ["city", "concrete", "modern", "setting"],
                "details": ["takes place in a city setting with concrete buildings, skyscrapers, neon lights, and modern architecture", "creates an urban and fast-paced atmosphere"],
                "objects": ["cars", "taxis", "buses", "train", "subway", "buildings", "billboards", "street lights", "sidewalks"]
            },
            {
                "name": "Rainforest",
                "keywords": ["jungle", "rainforest", "dense", "setting"],
                "details": ["takes place in a jungle or rainforest setting with dense vegetation, exotic animals, and lush landscapes", "creates a dense and mysterious atmosphere"],
                "objects": ["tropical plants", "exotic animals", "rain", "waterfalls", "moss", "butterflies"]
            },
            {
                "name": "Jungle",
                "keywords": ["jungle", "rainforest", "tropical", "setting"],
                "details": ["takes place in a jungle setting with rainforests, tropical plants, and exotic animals", "creates a mysterious and exotic atmosphere"],
                "objects": ["rainforests", "tropical plants", "exotic animals", "jungle plants", "jungle animals", "jungle architecture"]
            },
            {
                "name": "Mountain",
                "keywords": ["mountains", "rugged", "adventurous", "setting"],
                "details": ["takes place in a mountainous setting with rugged terrain, beautiful landscapes, and snow-capped peaks", "creates an adventurous and wild atmosphere"],
                "objects": ["hiking boots", "backpacks", "tents", "campfires", "mountains", "rocks", "snow"]
            },
            {
                "name": "Mountain",
                "keywords": ["mountain", "snow", "cold", "setting"],
                "details": ["takes place in a mountain setting with snow, cold weather, and icy terrain", "creates a mysterious and exotic atmosphere"],
                "objects": ["snow", "cold weather", "icy terrain", "mountains", "snowy trees", "snowy animals"]
            },
            {
                "name": "Rural Country",
                "keywords": ["countryside", "green", "natural", "setting"],
                "details": ["takes place in a countryside setting with green fields, farms, barns, and natural landscapes", "creates a peaceful and natural atmosphere"],
                "objects": ["trees", "fields", "flowers", "Country", "animals", "barns", "windmills"]
            },
            {
                "name": "Farm",
                "keywords": ["rural", "country", "farm", "setting"],
                "details": ["takes place in a rural setting with farms, country roads, and country architecture", "creates a mysterious and exotic atmosphere"],
                "objects": ["farms", "country roads", "Farm architecture", "cars", "buildings", "streets"]
            },
            {
                "name": "Beach",
                "keywords": ["ocean", "sandy", "relaxing", "setting"],
                "details": ["takes place at a beach with ocean views, sandy shores, and palm trees", "creates a relaxing and peaceful atmosphere"],
                "objects": ["beach umbrellas", "beach chairs", "beach towels", "beach balls", "surfboards", "seagulls"]
            },
            {
                "name": "Desert",
                "keywords": ["desert", "dry", "minimalistic", "setting"],
                "details": ["takes place in a desert setting with dry terrain, sand dunes, and minimalistic landscapes", "creates a minimalistic and lonely atmosphere"],
                "objects": ["cacti", "sand dunes", "camels", "tents", "desert plants", "sunset"]
            },
            {
                "name": "Steampunk",
                "keywords": ["steampunk", "steam", "clockwork", "setting"],
                "details": ["takes place in a steampunk setting with steam, clockwork, and mechanical elements", "creates a mysterious and exotic atmosphere"],
                "objects": ["steam", "clockwork", "mechanical elements", "mechanical weapons", "mechanical armor", "mechanical architecture"]
            },
            {
                "name": "Industrial",
                "keywords": ["factory", "gritty", "industrial", "setting"],
                "details": ["takes place in an industrial setting such as a factory, with large machinery, pipes, and dark lighting", "creates a gritty and industrial atmosphere"],
                "objects": ["machines", "pipes", "conveyor belts", "cranes", "smokestacks", "gears"]
            },
            {
                "name": "Historical",
                "keywords": ["historical", "old", "nostalgic", "setting"],
                "details": ["takes place in a historical setting such as an old castle or city, with old architecture, cobblestone streets, and antique shops", "creates a nostalgic and romantic atmosphere"],
                "objects": ["antique shops", "cobblestone streets", "old architecture", "antique cars", "old buildings", "old cars"]
            },
            {
                "name": "Sci-Fi",
                "keywords": ["futuristic", "technological", "fantasy", "setting"],
                "details": ["takes place in a futuristic or science fiction setting with advanced technology, fantasy elements, and futuristic architecture", "creates a technological and exciting atmosphere"],
                "objects": ["futuristic architecture", "futuristic cars", "futuristic buildings", "futuristic robots", "futuristic technology", "futuristic weapons"]
            },
            {
                "name": "Underwater",
                "keywords": ["underwater", "ocean", "mysterious", "setting"],
                "details": ["takes place underwater in an ocean setting with mysterious creatures, exotic plants, and ancient architecture", "creates a mysterious and exotic atmosphere"],
                "objects": ["mysterious creatures", "exotic plants", "ancient architecture", "ocean waves", "ocean plants", "ocean animals"]
            },
            {
                "name": "Underwater",
                "keywords": ["underwater", "ocean", "mysterious", "setting"],
                "details": ["takes place underwater in an ocean setting with exotic fish, coral reefs, and mysterious creatures", "creates a mysterious and exotic atmosphere"],
                "objects": ["coral reefs", "exotic fish", "mysterious creatures", "ocean waves", "ocean plants", "ocean animals"]
            },
            {
                "name": "Western",
                "keywords": ["western", "cowboy", "ranch", "setting"],
                "details": ["takes place in a western setting with cowboys, ranches, and horses", "creates a mysterious and exotic atmosphere"],
                "objects": ["cowboys", "ranches ", "horses", "guns", "cacti", "cows"]
            },
            {
                "name": "Space",
                "keywords": ["space", "stars", "galaxy", "setting"],
                "details": ["takes place in space in a galaxy setting with stars, planets, and space ships", "creates a mysterious and exotic atmosphere"],
                "objects": ["stars", "planets", "space ships", "space plants", "space animals", "space architecture"]
            },
            // {
            //     "name": "Space",
            //     "keywords": ["space", "astronaut", "stars", "setting"],
            //     "details": ["takes place in space with stars, planets, and astronauts", "creates a mysterious and exotic atmosphere"],
            //     "objects": ["stars", "planets", "astronauts", "space ships", "space stations", "space suits"]
            // },
            {
                "name": "Fantasy",
                "keywords": ["fantasy", "magic", "mythical", "setting"],
                "details": ["takes place in a fantasy setting with mythical creatures, magic, and fantasy elements", "creates a mysterious and exotic atmosphere"],
                "objects": ["mythical creatures", "magic", "fantasy elements", "fantasy weapons", "fantasy armor", "fantasy architecture"]
            },
            {
                "name": "Mystical",
                "keywords": ["mystical", "mysterious", "magical", "setting"],
                "details": ["takes place in a mystical setting with magical creatures, mysterious elements, and magical powers", "creates a mysterious and exotic atmosphere"],
                "objects": ["magical creatures", "mysterious elements", "magical powers", "magical weapons", "magical armor", "magical architecture"]
            },
            {
                "name": "Apocalyptic",
                "keywords": ["apocalyptic", "post-apocalyptic", "zombie", "setting"],
                "details": ["takes place in an apocalyptic setting with zombies, post-apocalyptic architecture, and nuclear fallout", "creates a mysterious and exotic atmosphere"],
                "objects": ["zombies", "post-apocalyptic architecture", "nuclear fallout", "nuclear weapons", "nuclear bombs", "nuclear power plants"]
            },
            {
                "name": "Horror",
                "keywords": ["horror", "scary", "creepy", "setting"],
                "details": ["takes place in a horror setting with scary creatures, creepy elements, and spooky architecture", "creates a mysterious and exotic atmosphere"],
                "objects": ["scary creatures", "creepy elements", "spooky architecture", "spooky weapons", "spooky armor", "spooky architecture"]
            },
            {
                "name": "Tropical",
                "keywords": ["tropical", "beach", "paradise", "setting"],
                "details": ["takes place in a tropical paradise setting with crystal clear waters, white sandy beaches, and palm trees", "creates a paradise and exotic atmosphere"],
                "objects": ["palm trees", "white sandy beaches", "coconut trees", "sea shells", "paradise islands"]
            },
            {
                "name": "Medieval",
                "keywords": ["medieval", "castle", "knight", "setting"],
                "details": ["takes place in a medieval setting with castles, knights, and horses", "creates a mysterious and exotic atmosphere"],
                "objects": ["castles", "knights", "horses", "swords", "armor", "archery"]
            },
            {
                "name": "Modern",
                "keywords": ["modern", "city", "urban", "setting"],
                "details": ["takes place in a modern setting with cities, skyscrapers, and urban architecture", "creates a mysterious and exotic atmosphere"],
                "objects": ["cities", "skyscrapers", "urban architecture", "cars", "buildings", "streets"]
            },
            {
                "name": "Urban1",
                "keywords": ["urban", "city", "modern", "setting"],
                "details": ["takes place in an urban setting with cities, skyscrapers, and modern architecture", "creates a mysterious and exotic atmosphere"],
                "objects": ["cities", "skyscrapers", "modern architecture", "cars", "buildings", "streets"]
            },
            {
                "name": "Suburban",
                "keywords": ["suburban", "city", "neighborhood", "setting"],
                "details": ["takes place in a suburban setting with cities, houses, and neighborhoods", "creates a mysterious and exotic atmosphere"],
                "objects": ["cities", "houses", "neighborhoods", "cars", "buildings", "streets"]
            },
            {
                "name": "Island",
                "keywords": ["island", "ocean", "beach", "setting"],
                "details": ["takes place on an island in an ocean setting with beaches, palm trees, and exotic animals", "creates a mysterious and exotic atmosphere"],
                "objects": ["beaches", "palm trees", "exotic animals", "ocean waves", "ocean plants", "ocean animals"]
            },
            {
                "name": "Forest",
                "keywords": ["forest", "woods", "trees", "setting"],
                "details": ["takes place in a forest setting with woods, trees, and wildlife", "creates a mysterious and exotic atmosphere"],
                "objects": ["woods", "trees", "wildlife", "forest plants", "forest animals", "forest architecture"]
            },
            {
                "name": "Underground",
                "keywords": ["underground", "cave", "dungeon", "setting"],
                "details": ["takes place underground in a cave or dungeon setting with dark tunnels, mysterious creatures, and ancient architecture", "creates a mysterious and exotic atmosphere"],
                "objects": ["dark tunnels", "mysterious creatures", "ancient architecture", "cave plants", "cave animals", "cave architecture"]
            },
            {
                "name": "Los Angeles",
                "keywords": ["los angeles", "la", "california", "setting"],
                "details": ["takes place in los angeles, california in a city setting with skyscrapers, cars, and urban architecture", "creates a mysterious and exotic atmosphere"],
                "objects": ["skyscrapers", "cars", "urban architecture", "buildings", "streets", "city architecture"]
            },
            {
                "name": "New York",
                "keywords": ["new york", "ny", "new york city", "setting"],
                "details": ["takes place in new york city, new york in a city setting with skyscrapers, cars, and urban architecture", "creates a mysterious and exotic atmosphere"],
                "objects": ["skyscrapers", "cars", "urban architecture", "buildings", "streets", "city architecture"]
            },
            {
                "name": "1920s",
                "keywords": ["1920s", "1920", "roaring twenties", "setting"],
                "details": ["takes place in the 1920s in a city setting with skyscrapers, cars, and urban architecture", "creates a mysterious and exotic atmosphere"],
                "objects": ["vintage cars", "vintage architecture", "vintage clothing"]
            }
        ]
    },
    outdoorSettings: {
        "name": "Outdoor",
        styles: [
            {
                "name": "Mountain",
                "keywords": ["mountains", "rugged", "adventurous", "setting"],
                "details": ["takes place in a mountainous setting with rugged terrain and beautiful landscapes", "creates an adventurous and wild atmosphere"]
            },
            {
                "name": "Desert",
                "keywords": ["desert", "dry", "minimalistic", "setting"],
                "details": ["takes place in a desert setting with dry terrain and minimalistic landscapes", "creates a minimalistic and lonely atmosphere"]
            },
            {
                "name": "Jungle",
                "keywords": ["jungle", "rainforest", "dense", "setting"],
                "details": ["takes place in a jungle or rainforest setting with dense vegetation", "creates a dense and mysterious atmosphere"]
            },
            {
                "name": "Urban",
                "keywords": ["city", "concrete", "modern", "setting"],
                "details": ["takes place in a city setting with concrete buildings and modern architecture", "creates an urban and fast-paced atmosphere"]
            },
            {
                "name": "Beach",
                "keywords": ["ocean", "sandy", "relaxing", "setting"],
                "details": ["takes place at a beach with ocean views and sandy shores", "creates a relaxing and peaceful atmosphere"]
            },
            {
                "name": "Rural",
                "keywords": ["countryside", "green", "natural", "setting"],
                "details": ["takes place in a countryside setting with green fields and natural landscapes", "creates a peaceful and natural atmosphere"]
            },
            {
                "name": "Industrial",
                "keywords": ["factory", "gritty", "industrial", "setting"],
                "details": ["takes place in an industrial setting such as a factory", "creates a gritty and industrial atmosphere"]
            },
            {
                "name": "Historical",
                "keywords": ["historical", "old", "nostalgic", "setting"],
                "details": ["takes place in a historical setting such as an old castle or city", "creates a nostalgic and romantic atmosphere"]
            },
            {
                "name": "Sci-Fi",
                "keywords": ["futuristic", "technological", "fantasy", "setting"],
                "details": ["takes place in a futuristic or science fiction setting with advanced technology and fantasy elements", "creates a technological and exciting atmosphere"]
            },
            {
                "name": "Underwater",
                "keywords": ["underwater", "ocean", "mysterious", "setting"],
                "details": ["takes place underwater in an ocean setting", "creates a mysterious and exotic atmosphere"]
            }]
    },
    indoorStyles: {
        name: "Indoor Styles",
        styles: [
            {
                "name": "House",
                "keywords": ["house", "city", "urban", "setting"],
                "details": ["takes place in a house setting with small rooms, narrow hallways, and modern furniture", "creates a mysterious and exotic atmosphere"],
                "objects": ["small rooms", "narrow hallways", "modern furniture", "house architecture", "house plants", "house animals"]
            },
            {
                "name": "Castle",
                "keywords": ["castle", "medieval", "knight", "setting"],
                "details": ["takes place in a castle setting with large rooms, grand staircases, and luxurious furniture", "creates a mysterious and exotic atmosphere"],
                "objects": ["large rooms", "grand staircases", "luxurious furniture", "castle architecture", "castle plants", "castle animals"]
            },
            {
                "name": "Cabin",
                "keywords": ["cabin", "country", "rural", "setting"],
                "details": ["takes place in a cabin setting with small rooms, narrow hallways, and modern furniture", "creates a mysterious and exotic atmosphere"],
                "objects": ["small rooms", "narrow hallways", "modern furniture", "cabin architecture", "cabin plants"]
            },
            {
                "name": "Bar",
                "keywords": ["bar", "cafe", "restaurant", "setting"],
                "details": ["takes place in a bar setting with tables, chairs, and drinks", "creates a mysterious and exotic atmosphere"],
                "objects": ["tables", "chairs", "drinks", "bar architecture", "bar plants"]
            },
            {
                "name": "Theme Park",
                "keywords": ["theme park", "rides", "roller coaster", "setting"],
                "details": ["takes place in a theme park setting with rides, roller coasters, and food stands", "creates a mysterious and exotic atmosphere"],
                "objects": ["rides", "roller coasters", "food stands", "theme park architecture", "theme park plants", "theme park animals"]
            },
            {
                "name": "Mansion",
                "keywords": ["mansion", "house", "home", "setting"],
                "details": ["takes place in a mansion setting with large rooms, grand staircases, and luxurious furniture", "creates a mysterious and exotic atmosphere"],
                "objects": ["large rooms", "grand staircases", "luxurious furniture", "mansion architecture", "mansion plants", "mansion animals"]
            },
            {
                "name": "Apartment",
                "keywords": ["apartment", "city", "urban", "setting"],
                "details": ["takes place in an apartment setting with small rooms, narrow hallways, and modern furniture", "creates a mysterious and exotic atmosphere"],
                "objects": ["small rooms", "narrow hallways", "modern furniture", "apartment architecture", "apartment plants", "apartment animals"]
            },
            {
                "name": "Office",
                "keywords": ["office", "work", "business", "setting"],
                "details": ["takes place in an office setting with cubicles, desks, and computers", "creates a mysterious and exotic atmosphere"],
                "objects": ["cubicles", "desks", "computers", "office architecture", "office plants"]
            },
            {
                "name": "School",
                "keywords": ["school", "classroom", "education", "setting"],
                "details": ["takes place in a school setting with classrooms, desks, and computers", "creates a mysterious and exotic atmosphere"],
                "objects": ["classrooms", "desks", "computers", "school architecture", "school plants"]
            },
            {
                "name": "Hospital",
                "keywords": ["hospital", "doctor", "nurse", "setting"],
                "details": ["takes place in a hospital setting with operating rooms, beds, and medical equipment", "creates a mysterious and exotic atmosphere"],
                "objects": ["operating rooms", "beds", "medical equipment", "hospital architecture", "hospital plants"]
            },
            {
                "name": "Restaurant",
                "keywords": ["restaurant", "cafe", "bar", "setting"],
                "details": ["takes place in a restaurant setting with dining rooms, tables, and chairs", "creates a mysterious and exotic atmosphere"],
                "objects": ["dining rooms", "tables", "chairs", "restaurant architecture", "restaurant plants"]
            },
            {
                "name": "Cafe",
                "keywords": ["cafe", "bar", "restaurant", "setting"],
                "details": ["takes place in a cafe setting with tables, chairs, and drinks", "creates a mysterious and exotic atmosphere"],
                "objects": ["tables", "chairs", "drinks", "cafe architecture", "cafe plants"]
            },
            {
                "name": "Library",
                "keywords": ["library", "book", "reading", "setting"],
                "details": ["takes place in a library setting with bookshelves, tables, and chairs", "creates a mysterious and exotic atmosphere"],
                "objects": ["bookshelves", "tables", "chairs", "library architecture", "library plants"]
            },
            {
                "name": "Church",
                "keywords": ["church", "god", "religion", "setting"],
                "details": ["takes place in a church setting with pews, altars, and stained glass windows", "creates a mysterious and exotic atmosphere"],
                "objects": ["pews", "altars", "stained glass windows", "church architecture", "church plants"]
            },
            {
                "name": "Cemetery",
                "keywords": ["cemetery", "graveyard", "death", "setting"],
                "details": ["takes place in a cemetery setting with tombstones, mausoleums, and crypts", "creates a mysterious and exotic atmosphere"],
                "objects": ["tombstones", "mausoleums", "crypts", "cemetery architecture", "cemetery plants"]
            },
            {
                "name": "Museum",
                "keywords": ["museum", "art", "exhibit", "setting"],
                "details": ["takes place in a museum setting with exhibits, statues, and paintings", "creates a mysterious and exotic atmosphere"],
                "objects": ["exhibits", "statues", "paintings", "museum architecture", "museum plants"]
            },
            {
                "name": "Theater",
                "keywords": ["theater", "stage", "play", "setting"],
                "details": ["takes place in a theater setting with stages, curtains, and lights", "creates a mysterious and exotic atmosphere"],
                "objects": ["stages", "curtains", "lights", "theater architecture", "theater plants"]
            },
            {
                "name": "Circus",
                "keywords": ["circus", "clown", "juggler", "setting"],
                "details": ["takes place in a circus setting with tents, trapezes, and animals", "creates a mysterious and exotic atmosphere"],
                "objects": ["tents", "trapezes", "animals", "circus architecture", "circus plants", "circus animals"]
            },
            {
                "name": "Zoo",
                "keywords": ["zoo", "animals", "exhibit", "setting"],
                "details": ["takes place in a zoo setting with exhibits, cages, and animals", "creates a mysterious and exotic atmosphere"],
                "objects": ["exhibits", "cages", "animals", "zoo architecture", "zoo plants", "zoo animals"]
            },
            {
                "name": "Aquarium",
                "keywords": ["aquarium", "fish", "exhibit", "setting"],
                "details": ["takes place in an aquarium setting with exhibits, tanks, and fish", "creates a mysterious and exotic atmosphere"],
                "objects": ["exhibits", "tanks", "fish", "aquarium architecture", "aquarium plants", "aquarium animals"]
            },
            {
                "name": "Planetarium",
                "keywords": ["planetarium", "stars", "exhibit", "setting"],
                "details": ["takes place in a planetarium setting with exhibits, telescopes, and stars", "creates a mysterious and exotic atmosphere"],
                "objects": ["exhibits", "telescopes", "stars", "planetarium architecture", "planetarium plants"]
            },
            {
                "name": "Mall",
                "keywords": ["mall", "shopping", "store", "setting"],
                "details": ["takes place in a mall setting with stores, escalators, and food courts", "creates a mysterious and exotic atmosphere"],
                "objects": ["stores", "escalators", "food courts", "mall architecture", "mall plants"]
            },
            {
                "name": "Supermarket",
                "keywords": ["supermarket", "grocery store", "store", "setting"],
                "details": ["takes place in a supermarket setting with aisles, shelves, and checkout counters", "creates a mysterious and exotic atmosphere"],
                "objects": ["aisles", "shelves", "checkout counters", "supermarket architecture", "supermarket plants"]
            },
            {
                "name": "Grocery Store",
                "keywords": ["grocery store", "supermarket", "store", "setting"],
                "details": ["takes place in a grocery store setting with aisles, shelves, and checkout counters", "creates a mysterious and exotic atmosphere"],
                "objects": ["aisles", "shelves", "checkout counters", "grocery store architecture", "grocery store plants"]
            },
            {
                "name": "Convenience Store",
                "keywords": ["convenience store", "store", "setting"],
                "details": ["takes place in a convenience store setting with aisles, shelves, and checkout counters", "creates a mysterious and exotic atmosphere"],
                "objects": ["aisles", "shelves", "checkout counters", "convenience store architecture", "convenience store plants"]
            },
            {
                "name": "Gas Station",
                "keywords": ["gas station", "store", "setting"],
                "details": ["takes place in a gas station setting with pumps, shelves, and checkout counters", "creates a mysterious and exotic atmosphere"],
                "objects": ["pumps", "shelves", "checkout counters", "gas station architecture", "gas station plants"]
            },
            {
                "name": "Hardware Store",
                "keywords": ["hardware store", "store", "setting"],
                "details": ["takes place in a hardware store setting with aisles, shelves, and checkout counters", "creates a mysterious and exotic atmosphere"],
                "objects": ["aisles", "shelves", "checkout counters", "hardware store architecture", "hardware store plants"]
            },
            {
                "name": "Clothing Store",
                "keywords": ["clothing store", "store", "setting"],
                "details": ["takes place in a clothing store setting with aisles, shelves, and checkout counters", "creates a mysterious and exotic atmosphere"],
                "objects": ["aisles", "shelves", "checkout counters", "clothing store architecture", "clothing store plants"]
            },
            {
                "name": "Toy Store",
                "keywords": ["toy store", "store", "setting"],
                "details": ["takes place in a toy store setting with aisles, shelves, and checkout counters", "creates a mysterious and exotic atmosphere"],
                "objects": ["aisles", "shelves", "checkout counters", "toy store architecture", "toy store plants"]
            },
        ]
    },
    skyStyles: {
        "name": "Sky Styles",
        "styles": [
            {
                "name": "Dramatic",
                "keywords": ["dramatic", "dark", "stormy", "sky"],
                "details": ["features a dramatic and dark sky with stormy clouds, often with a strong contrast between light and dark", "creates a dramatic and ominous atmosphere"],
                "objects": ["dark clouds", "lightning", "thunder", "rain", "wind"]
            },
            {
                "name": "Sunset",
                "keywords": ["sunset", "orange", "pink", "sky"],
                "details": ["features a sunset sky with orange and pink hues, often with a soft and warm light", "creates a romantic and warm atmosphere"],
                "objects": ["orange and pink hues", "soft light", "sunset clouds", "sun rays", "warmth"]
            },
            {
                "name": "Morning",
                "keywords": ["morning", "orange", "yellow", "sky"],
                "details": ["features a morning sky with orange and yellow hues, often with a soft and warm light", "creates a fresh and warm atmosphere"],
                "objects": ["orange and yellow hues", "soft light", "morning clouds", "sun rays", "warmth"]
            },
            {
                "name": "Overcast",
                "keywords": ["overcast", "gray", "moody", "sky"],
                "details": ["features an overcast sky with a gray and moody hue, often with a diffuse light", "creates a moody and mysterious atmosphere"],
                "objects": ["gray clouds", "diffuse light", "fog", "mist", "gloomy"]
            },
            {
                "name": "Night",
                "keywords": ["night", "black", "dark", "sky"],
                "details": ["features a night sky with a black and dark hue, often with stars and a moon", "creates a mysterious and dark atmosphere"],
                "objects": ["black sky", "stars", "moon", "city lights", "dark"]
            },
            {
                "name": "Nautical",
                "keywords": ["nautical", "blue", "clear", "sky"],
                "details": ["features a nautical sky with a clear and bright blue hue, often with white clouds", "creates a clean and fresh atmosphere"],
                "objects": ["clear blue sky", "white clouds", "sail boats", "ocean", "beach"]
            },
            {
                "name": "Dusk",
                "keywords": ["dusk", "purple", "pink", "sky"],
                "details": ["features a dusk sky with purple and pink hues, often with a soft and warm light", "creates a romantic and warm atmosphere"],
                "objects": ["purple and pink hues", "soft light", "dusk clouds", "sun rays", "warmth"]
            },
            {
                "name": "Rainbow",
                "keywords": ["rainbow", "colorful", "vibrant", "sky"],
                "details": ["features a sky with a colorful and vibrant rainbow, often with a bright light", "creates a vibrant and joyful atmosphere"],
                "objects": ["rainbow", "colorful sky", "sun rays", "rain", "vibrant"]
            },
            {
                "name": "Aurora",
                "keywords": ["aurora", "green", "purple", "sky"],
                "details": ["features a sky with aurora lights, often with a green and purple hue", "creates a magical and mysterious atmosphere"],
                "objects": ["aurora lights", "green and purple hues", "northern lights", "stars", "mysterious"]
            },
            {
                "name": "Smoke",
                "keywords": ["smoke", "hazy", "foggy", "sky"],
                "details": ["features a sky with a hazy and foggy smoke, often with a gray and dark hue", "creates a mysterious and dark atmosphere"],
                "objects": ["smoke", "hazy sky", "foggy", "dark", "mysterious"]
            },
            {
                "name": "Fireworks",
                "keywords": ["fireworks", "colorful", "bright", "sky"],
                "details": ["features a sky with colorful and bright fireworks, often with a festive atmosphere", "creates a celebratory and joyful atmosphere"],
                "objects": ["fireworks", "colorful sky", "bright lights", "festive", "joyful"]
            },
            {
                "name": "Cloudy",
                "keywords": ["cloudy", "gray", "overcast", "sky"],
                "details": ["features a cloudy sky with a gray and overcast hue, often with a diffuse light", "creates a moody and mysterious atmosphere"],
                "objects": ["gray clouds", "diffuse light", "overcast", "moody", "mysterious"]
            },
            {
                "name": "Cotton candy",
                "keywords": ["cotton candy", "pink", "blue", "sky"],
                "details": ["features a sky with a pink and blue cotton candy hue, often with a sweet and whimsical atmosphere", "creates a playful and whimsical atmosphere"],
                "objects": ["pink and blue hues", "cotton candy clouds", "whimsical", "playful", "sweet"]
            },
            {
                "name": "Cherry blossom",
                "keywords": ["cherry blossom", "pink", "spring", "sky"],
                "details": ["features a sky with a pink cherry blossom hue, often with a soft and warm light", "creates a romantic and warm atmosphere"],
                "objects": ["pink cherry blossom", "soft light", "spring", "warmth", "romantic"]
            },
        ]
    },
    interiorStyles: {
        "name": "Interior Styles",
        "styles": [
            {
                "name": "Minimalist",
                "keywords": ["minimalist", "clean", "simple", "indoor"],
                "details": ["features a minimalist and clean aesthetic with simple and uncluttered spaces", "creates a modern and uncluttered atmosphere"],
                "objects": ["white walls", "simple furniture", "minimal decor", "plants", "natural light"]
            },
            {
                "name": "Rustic",
                "keywords": ["rustic", "cozy", "warm", "indoor"],
                "details": ["features a rustic aesthetic with warm and cozy spaces, often incorporating natural materials such as wood and stone", "creates a warm and inviting atmosphere"],
                "objects": ["wooden beams", "stone fireplaces", "plaid patterns", "candles", "rustic furniture"]
            },
            {
                "name": "Industrial",
                "keywords": ["industrial", "edgy", "urban", "indoor"],
                "details": ["features an industrial aesthetic with edgy and urban spaces, often incorporating raw materials such as concrete and metal", "creates an edgy and urban atmosphere"],
                "objects": ["concrete walls", "exposed pipes", "metal accents", "factory lights", "warehouse elements"]
            },
            {
                "name": "Glamorous",
                "keywords": ["glamorous", "luxurious", "opulent", "indoor"],
                "details": ["features a glamorous and luxurious aesthetic with opulent spaces, often incorporating elements such as chandeliers, velvet and gold accents", "creates a luxurious and opulent atmosphere"],
                "objects": ["chandeliers", "velvet accents", "gold accents", "crystal", "marble"]
            },
            {
                "name": "Bohemian",
                "keywords": ["bohemian", "eclectic", "quirky", "indoor"],
                "details": ["features a bohemian aesthetic with eclectic and quirky spaces, often incorporating elements such as patterned textiles, plants, and vintage decor", "creates a bohemian and free-spirited atmosphere"],
                "objects": ["patterned textiles", "plants", "vintage decor", "global accents", "mixed patterns"]
            },
            {
                "name": "Scandinavian",
                "keywords": ["scandinavian", "minimalist", "simple", "indoor"],
                "details": ["features a scandinavian aesthetic with minimalist and simple spaces, often incorporating elements such as natural light, white walls, and natural materials", "creates a minimalist and cozy atmosphere"],
                "objects": ["white walls", "natural light", "natural materials", "wooden floors", "minimal decor"]
            },
            {
                "name": "Mid-Century Modern",
                "keywords": ["mid-century modern", "retro", "vintage", "indoor"],
                "details": ["features a mid-century modern aesthetic with retro and vintage spaces, often incorporating elements such as geometric patterns, clean lines, and natural wood", "creates a retro and vintage atmosphere"],
                "objects": ["geometric patterns", "clean lines", "natural wood", "atomic shapes", "pop of color"]
            },
            {
                "name": "Mediterranean",
                "keywords": ["mediterranean", "tuscan", "old world", "indoor"],
                "details": ["features a Mediterranean aesthetic with Tuscan and old world spaces, often incorporating elements such as stone walls, arches, and wrought iron", "creates a Tuscan and old world atmosphere"],
                "objects": ["stone walls", "arches", "wrought iron", "copper accents", "wooden beams"]
            },
            {
                "name": "Modern",
                "keywords": ["modern", "contemporary", "clean", "indoor"],
                "details": ["features a modern aesthetic with contemporary and clean spaces, often incorporating elements such as white walls, clean lines, and minimal decor", "creates a modern and uncluttered atmosphere"],
                "objects": ["white walls", "clean lines", "minimal decor", "natural light", "plants"]
            },
            {
                "name": "Traditional",
                "keywords": ["traditional", "classic", "elegant", "indoor"],
                "details": ["features a traditional aesthetic with classic and elegant spaces, often incorporating elements such as chandeliers, wood accents, and patterned textiles", "creates a classic and elegant atmosphere"],
                "objects": ["chandeliers", "wood accents", "patterned textiles", "candles", "marble"]
            },
            {
                "name": "Victorian",
                "keywords": ["victorian", "classic", "elegant", "indoor"],
                "details": ["features a Victorian aesthetic with classic and elegant spaces, often incorporating elements such as chandeliers, wood accents, and patterned textiles", "creates a classic and elegant atmosphere"],
                "objects": ["chandeliers", "wood accents", "patterned textiles", "candles", "marble"]
            },
            {
                "name": "French",
                "keywords": ["french", "classic", "elegant", "indoor"],
                "details": ["features a French aesthetic with classic and elegant spaces, often incorporating elements such as chandeliers, wood accents, and patterned textiles", "creates a classic and elegant atmosphere"],
                "objects": ["chandeliers", "wood accents", "patterned textiles", "candles", "marble"]
            },
            {
                "name": "Japanese",
                "keywords": ["japanese", "minimalist", "simple", "indoor"],
                "details": ["features a Japanese aesthetic with minimalist and simple spaces, often incorporating elements such as natural light, white walls, and natural materials", "creates a minimalist and cozy atmosphere"],
                "objects": ["white walls", "natural light", "natural materials", "wooden floors", "minimal decor"]
            },
            {
                "name": "Asian",
                "keywords": ["asian", "minimalist", "simple", "indoor"],
                "details": ["features an Asian aesthetic with minimalist and simple spaces, often incorporating elements such as natural light, white walls, and natural materials", "creates a minimalist and cozy atmosphere"],
                "objects": ["white walls", "natural light", "natural materials", "wooden floors", "minimal decor"]
            },
            {
                "name": "Tropical",
                "keywords": ["tropical", "exotic", "exotic", "indoor"],
                "details": ["features a tropical aesthetic with exotic and exotic spaces, often incorporating elements such as natural light, white walls, and natural materials", "creates a mysterious and exotic atmosphere"],
                "objects": ["white walls", "natural light", "natural materials", "wooden floors", "minimal decor"]
            },
            {
                "name": "Beach",
                "keywords": ["beach", "coastal", "coastal", "indoor"],
                "details": ["features a beach aesthetic with coastal and coastal spaces, often incorporating elements such as natural light, white walls, and natural materials", "creates a mysterious and exotic atmosphere"],
                "objects": ["white walls", "natural light", "natural materials", "wooden floors", "minimal decor"]
            },
            {
                "name": "Coastal",
                "keywords": ["coastal", "coastal", "coastal", "indoor"],
                "details": ["features a coastal aesthetic with coastal and coastal spaces, often incorporating elements such as natural light, white walls, and natural materials", "creates a mysterious and exotic atmosphere"],
                "objects": ["white walls", "natural light", "natural materials", "wooden floors", "minimal decor"]
            },
            {
                "name": "Nautical",
                "keywords": ["nautical", "coastal", "coastal", "indoor"],
                "details": ["features a nautical aesthetic with coastal and coastal spaces, often incorporating elements such as natural light, white walls, and natural materials", "creates a mysterious and exotic atmosphere"],
                "objects": ["white walls", "natural light", "natural materials", "wooden floors", "minimal decor"]
            },
            {
                "name": "Contemporary",
                "keywords": ["contemporary", "modern", "clean", "indoor"],
                "details": ["features a contemporary aesthetic with modern and clean spaces, often incorporating elements such as white walls, clean lines, and minimal decor", "creates a modern and uncluttered atmosphere"],
                "objects": ["white walls", "clean lines", "minimal decor", "natural light", "plants"]
            },
            {
                "name": "Rustic",
                "keywords": ["rustic", "country", "farmhouse", "indoor"],
                "details": ["features a rustic aesthetic with country and farmhouse spaces, often incorporating elements such as wood accents, natural light, and patterned textiles", "creates a country and farmhouse atmosphere"],
                "objects": ["wood accents", "natural light", "patterned textiles"]
            },
            {
                "name": "Country",
                "keywords": ["country", "rustic", "farmhouse", "indoor"],
                "details": ["features a country aesthetic with rustic and farmhouse spaces, often incorporating elements such as wood accents, natural light, and patterned textiles", "creates a rustic and farmhouse atmosphere"],
                "objects": ["wood accents", "natural light", "patterned textiles"]
            },
            {
                "name": "Farmhouse",
                "keywords": ["farmhouse", "rustic", "country", "indoor"],
                "details": ["features a farmhouse aesthetic with rustic and country spaces, often incorporating elements such as wood accents, natural light, and patterned textiles", "creates a rustic and country atmosphere"],
                "objects": ["wood accents", "natural light", "patterned textiles"]
            },
            {
                "name": "Industrial",
                "keywords": ["industrial", "urban", "industrial", "indoor"],
                "details": ["features an industrial aesthetic with urban and industrial spaces, often incorporating elements such as exposed brick, metal accents, and concrete floors", "creates an urban and industrial atmosphere"],
                "objects": ["exposed brick", "metal accents", "concrete floors"]
            },
            {
                "name": "Urban",
                "keywords": ["urban", "industrial", "industrial", "indoor"],
                "details": ["features an urban aesthetic with industrial and industrial spaces, often incorporating elements such as exposed brick, metal accents, and concrete floors", "creates an industrial and industrial atmosphere"],
                "objects": ["exposed brick", "metal accents", "concrete floors"]
            }
        ]
    },
};
//return a list of all tones imagwStaging
//return a array of all objects imagwStaging
//flatten allObjects and de-duplicate
//deduplicate all tones
// let allTonesDedup = {...new Set(allTones.flat())};
//return all objects from imagwStaging
let stillLifeStyles = [
    {
        "name": "Still Life",
        "keywords": ["still life", "still-life", "stilllife", "setting"],
        "details": ["takes place in a still life setting with inanimate objects", "creates a mysterious and exotic atmosphere"],
        "objects": ["inanimate objects", "still life objects", "still life architecture"]
    },
    {
        "name": "Still Life 1",
        "keywords": ["still life", "still-life", "stilllife", "setting"],
        "details": ["takes place in a still life setting with inanimate objects", "creates a mysterious and exotic atmosphere"],
        "objects": ["inanimate objects", "still life objects", "still life architecture"]
    },

];
//// "tilt shot",// "underwater shot",// "panning shot",// "tracking shot",// "handheld shot",// "dolly shot",// "zoom shot",
let shots = [
    "Establishing shot",
    "Close-up shot",
    "Medium-shot",
    "Medium-wide shot",
    "Over-the-shoulder shot",
    "Wide-shot",
    // "Overhead shot",
    // "Extreme close-up shot",
    // "Extreme long-shot",
    // "POV shot"
    // "Extreme-wide shot",
    // "Long-shot",
    // "Crane shot",
];
let photographyStyle = [
    {
        name: "Conceptual Portrait",
        lens: "wide angle lens",
        lighting: "editorial with hairlight",
        composition: "head and shoulders",
        shot: "close-up shot",
        details: "features a conceptual portrait with a wide angle lens, natural light, and a head and shoulders composition",
        environment: "blue sky",
        colorProfile: "vivid",
        references: "vanity fair, vogue",
        inspiredBy: "Magritte, Dali"
    }
];
let portraitStyles = [
    {
        name: "Conceptual Self-Portrait",
        lens: "normal lens, 50mm",
        lighting: "natural light",
        composition: "head and shoulders",
        shot: "close-up shot",
        details: "features a conceptual self-portrait with a normal lens, natural light, and a head and shoulders composition",
        environment: "indoors or outdoors with minimalistic background",
        colorProfile: "moody and atmospheric",
        references: "i-D, Dazed",
        inspiredBy: "Frida Kahlo, Cindy Sherman"
    },
    {
        name: "Conceptual Portrait with Props",
        lens: "normal lens, 50mm",
        lighting: "natural light",
        composition: "head and shoulders",
        shot: "close-up shot",
        details: "features a conceptual portrait with props and a normal lens, natural light, and a head and shoulders composition",
        environment: "indoors or outdoors with minimalistic background",
        colorProfile: "surreal and dreamlike",
        references: "Wired, New York Times Magazine",
        inspiredBy: "Tim Walker, Platon"
    },
    {
        name: "Conceptual Portrait with Conceptual Clothing",
        lens: "normal lens, 50mm",
        lighting: "natural light",
        composition: "head and shoulders",
        shot: "close-up shot",
        details: "features a conceptual portrait with conceptual clothing and a normal lens, natural light, and a head and shoulders composition",
        environment: "indoors or outdoors with minimalistic background",
        colorProfile: "high-fashion and avant-garde",
        references: "Vogue, Harper's Bazaar",
        inspiredBy: "Alexander McQueen, Comme des Garçons"
    },
    {
        name: "Conceptual Portrait with Conceptual Makeup",
        lens: "normal lens, 50mm",
        lighting: "natural light",
        composition: "head and shoulders",
        shot: "close-up shot",
        details: "features a conceptual portrait with conceptual makeup and a normal lens, natural light, and a head and shoulders composition",
        environment: "indoors or outdoors with minimalistic background",
        colorProfile: "creative and experimental",
        references: "Interview, Paper",
        inspiredBy: "Pat McGrath, Rick Baker"
    },
    {
        name: "Conceptual Portrait with Conceptual Hair",
        lens: "normal lens, 50mm",
        lighting: "natural light",
        composition: "head and shoulders",
        shot: "close-up shot",
        details: "features a conceptual portrait with conceptual hair and a normal lens, natural light, and a head and shoulders composition",
        environment: "indoors or outdoors with minimalistic background",
        colorProfile: "bold and colorful",
        references: "Punk, Dazed",
        inspiredBy: "Guido Palau, Shon Ju"
    },
    {
        name: "Ethereal Beauty",
        lens: "normal lens, 50mm",
        lighting: "natural light with a hint of backlight",
        composition: "head and shoulders",
        shot: "close-up shot",
        details: "features a ethereal beauty look with a normal lens, natural light, and a head and shoulders composition",
        environment: "outdoors in a natural setting, such as a forest or meadow",
        colorProfile: "soft and dreamy",
        references: "Vogue, Harper's Bazaar",
        inspiredBy: "Tim Walker, Steven Meisel"
    },
    {
        name: "Futuristic Fashion",
        lens: "normal lens, 50mm",
        lighting: "studio with strobe lights",
        composition: "full body",
        shot: "medium shot",
        details: "features a futuristic fashion look with a normal lens, studio lighting, and a full body composition",
        environment: "studio with a minimalist, futuristic background",
        colorProfile: "high-contrast and graphic",
        references: "i-D, Dazed",
        inspiredBy: "Nick Knight, Steven Klein"
    },
    {
        name: "Surreal Self-Portrait",
        lens: "normal lens, 50mm",
        lighting: "natural light",
        composition: "head and shoulders",
        shot: "close-up shot",
        details: "features a surreal self-portrait with a normal lens, natural light, and a head and shoulders composition",
        environment: "indoors with a surreal background",
        colorProfile: "surreal and dreamlike",
        references: "Wired, New York Times Magazine",
        inspiredBy: "Frida Kahlo, Cindy Sherman"
    },
    {
        name: "Fantasy Fashion",
        lens: "telephoto lens, 85mm",
        lighting: "studio with softboxes",
        composition: "full body",
        shot: "medium shot",
        details: "features a fantasy fashion look with a telephoto lens, studio lighting, and a full body composition",
        environment: "studio with a fantasy-inspired background",
        colorProfile: "fantasy-inspired and whimsical",
        references: "Vogue, Harper's Bazaar",
        inspiredBy: "Alexander McQueen, Comme des Garçons"
    },
    {
        name: "Futuristic Beauty",
        lens: "normal lens, 50mm",
        lighting: "studio with strobe lights",
        composition: "head and shoulders",
        shot: "close-up shot",
        details: "features a futuristic beauty look with a normal lens, studio lighting, and a head and shoulders composition",
        environment: "studio with a minimalist, futuristic background",
        colorProfile: "high-contrast and graphic",
        references: "Allure, W Magazine",
        inspiredBy: "Pat McGrath, Rick Baker"
    },
    {
        name: "Futuristic Cityscape",
        lens: "wide angle lens, 14-24mm",
        lighting: "natural light with a hint of artificial light",
        composition: "landscape shot",
        shot: "wide shot",
        details: "features a futuristic cityscape with a wide angle lens, a combination of natural and artificial light, and a landscape composition",
        environment: "an urban setting, featuring skyscrapers and other futuristic elements",
        colorProfile: "high-contrast and graphic",
        references: "Wired, New York Times Magazine",
        inspiredBy: "Eric Francis, Vincent Laforet"
    },
    {
        name: "Surreal Landscape with People",
        lens: "telephoto lens, 85mm",
        lighting: "natural light with a hint of artificial light",
        composition: "landscape shot",
        shot: "wide shot",
        details: "features a surreal landscape with people and a telephoto lens, natural light with a hint of artificial light, and a landscape composition",
        environment: "a unique outdoor location, such as a desert or a forest, with surreal elements",
        colorProfile: "surreal and dreamlike",
        references: "National Geographic, Ansel Adams",
        inspiredBy: "Salvador Dali, Rene Magritte"
    },
    {
        name: "Futuristic Fashion with People",
        lens: "normal lens, 50mm",
        lighting: "studio with strobe lights",
        composition: "full body",
        shot: "medium shot",
        details: "features a futuristic fashion look with people and a normal lens, studio lighting, and a full body composition",
        environment: "studio with a minimalist, futuristic background",
        colorProfile: "high-contrast and graphic",
        references: "i-D, Dazed",
        inspiredBy: "Nick Knight, Steven Klein"
    },
    {
        name: "Fantasy Scene with People",
        lens: "telephoto lens, 85mm",
        lighting: "studio with softboxes",
        composition: "full body",
        shot: "medium shot",
        details: "features a fantasy scene with people, a telephoto lens, studio lighting, and a full body composition",
        environment: "studio with a fantasy-inspired background",
        colorProfile: "fantasy-inspired and whimsical",
        references: "Fantasy & Science Fiction, Jules Verne",
        inspiredBy: "Peter Jackson, Guillermo del Toro"
    },
    {
        name: "Futuristic Beauty with People",
        lens: "normal lens, 50mm",
        lighting: "studio with strobe lights",
        composition: "full body",
        shot: "medium shot",
        details: "features a futuristic beauty look with people, a normal lens, studio lighting, and a full body composition",
        environment: "studio with a minimalist, futuristic background",
        colorProfile: "high-contrast and graphic",
        references: "Allure, W Magazine",
        inspiredBy: "Pat McGrath, Rick Baker"
    },
    {
        name: "Futuristic Cityscape",
        lens: "wide angle lens, 14-24mm",
        lighting: "natural light with a hint of artificial light",
        composition: "landscape shot",
        shot: "wide shot",
        environment: "an urban setting, featuring skyscrapers and other futuristic elements",
        colorProfile: "high-contrast and graphic",
        references: "Wired, New York Times Magazine",
        inspiredBy: "Eric Francis, Vincent Laforet"
    },
    {
        name: "Surreal Landscape with People",
        lens: "telephoto lens, 85mm",
        lighting: "natural light with a hint of artificial light",
        composition: "landscape shot",
        shot: "wide shot",
        environment: "a unique outdoor location, such as a desert or a forest, with surreal elements",
        colorProfile: "surreal and dreamlike",
        references: "National Geographic, Ansel Adams",
        inspiredBy: "Salvador Dali, Rene Magritte"
    },
    {
        name: "Futuristic Fashion with People",
        lens: "normal lens, 50mm",
        lighting: "studio with strobe lights",
        composition: "full body",
        shot: "medium shot",
        environment: "studio with a minimalist, futuristic background",
        colorProfile: "high-contrast and graphic",
        references: "i-D, Dazed",
        inspiredBy: "Nick Knight, Steven Klein"
    },
    {
        name: "Fantasy Scene with People",
        lens: "telephoto lens, 85mm",
        lighting: "studio with softboxes",
        composition: "full body",
        shot: "medium shot",
        environment: "studio with a fantasy-inspired background",
        colorProfile: "fantasy-inspired and whimsical",
        references: "Fantasy & Science Fiction, Jules Verne",
        inspiredBy: "Peter Jackson, Guillermo del Toro"
    },
    {
        name: "Futuristic Beauty with People",
        lens: "normal lens, 50mm",
        lighting: "studio with strobe lights",
        composition: "full body",
        shot: "medium shot",
        environment: "studio with a minimalist, futuristic background",
        colorProfile: "high-contrast and graphic",
        references: "Allure, W Magazine",
        inspiredBy: "Pat McGrath, Rick Baker"
    }
];
let newPortraitStyles = [
    {
        "name": "Surreal Landscape with People",
        "lens": "telephoto lens, 85mm",
        "lighting": "natural light with a hint of artificial light",
        "composition": "landscape shot",
        "shot": "wide shot",
        "environment": "a unique outdoor location, such as a desert or a forest, with surreal elements",
        "colorProfile": "surreal and dreamlike",
        "photographer": "Jane Doe",
        "references": "National Geographic, Ansel Adams",
        "inspiredBy": "Salvador Dali, Rene Magritte",
        "intendedAudience": "Art Magazine",
        "timePeriod": "1940",
        "intendedUse": "spread",
        "mood": "surreal"
    },
    {
        "name": "Futuristic Cityscape",
        "lens": "wide angle lens, 14-24mm",
        "lighting": "natural light with a hint of artificial light",
        "composition": "landscape shot",
        "shot": "wide shot",
        "environment": "an urban setting, featuring skyscrapers and other futuristic elements",
        "colorProfile": "high-contrast and graphic",
        "photographer": "John Smith",
        "references": "Wired, New York Times Magazine",
        "inspiredBy": "Eric Francis, Vincent Laforet",
        "intendedAudience": "Fashion Magazine",
        "timePeriod": "2030",
        "intendedUse": "cover",
        "mood": "futuristic"
    },
    {
        "name": "Futuristic Fashion with People",
        "lens": "normal lens, 50mm",
        "lighting": "studio with strobe lights",
        "composition": "full body",
        "shot": "medium shot",
        "environment": "studio with a minimalist, futuristic background",
        "colorProfile": "high-contrast and graphic",
        "photographer": "Mark Johnson",
        "references": "i-D, Dazed",
        "inspiredBy": "Nick Knight, Steven Klein",
        "intendedAudience": "Fashion Magazine",
        "timePeriod": "2050",
        "intendedUse": "online",
        "mood": "futuristic"
    },
    {
        "name": "Fantasy Scene with People",
        "lens": "telephoto lens, 85mm",
        "lighting": "studio with softboxes",
        "composition": "full body",
        "shot": "medium shot",
        "environment": "studio with a fantasy-inspired background",
        "colorProfile": "fantasy-inspired and whimsical",
        "photographer": "Emily Davis",
        "references": "Fantasy & Science Fiction, Jules Verne",
        "inspiredBy": "Peter Jackson, Guillermo del Toro",
        "intendedAudience": "Fantasy Magazine",
        "timePeriod": "Medieval",
        "intendedUse": "spread",
        "mood": "fantasy"
    }
];
let camera = {
    angles: ["low angle", "high angle", "eye level", "Bird's eye view", "Isometric view"],
    shots: shots,
    advanced: {
        aperatue: ["ƒ/1", "ƒ/1.4", "ƒ2", "ƒ/2.8", "ƒ4", "ƒ/5.6", "ƒ/8", "ƒ/11", "ƒ/16", "ƒ/22"],
        lenses: ["100mm lens", "200mm lens", "24mm lens", "35mm lens", "50mm lens", "85mm lens", "telephoto lens", "wide-angle lens"],
        "ISO": ["ISO 100", "ISO 200", "ISO 400", "ISO 800", "ISO 1600", "ISO 3200",
            // "ISO 6400", "ISO 12500", "ISO 25600", "ISO 51200", "ISO 102400", "ISO 204800", "ISO 409600"
        ],
        "focus": ["Bokeh", "Depth of Field", "DoF", "Digital Camera", "Optical Camera", "Long Exposure", "Short Exposure", "Over Exposed", "Focused"],
    },
    // {"Camera": ["Canon EOS Rebel T7 DSLR Camera", "Sony a7 IV Mirrorless Camera", "Canon EOS R6 Mirrorless Camera", "Canon EOS 5D Mark IV DSLR Camera", "Sony a6600 Mirrorless Camera", "Canon EOS Rebel T7 DSLR Camera", "Canon EOS R6 Mirrorless Camera", "Canon EOS 5D Mark IV DSLR Camera", "Canon EOS RP Mirrorless Camera", "Canon EOS Rebel T8i DSLR Camera", "Canon EOS R5 Mirrorless Camera", "Canon EOS R Mirrorless Camera", "Canon EOS M6 Mark II Mirrorless Camera", "Canon EOS M50 Mark II Mirrorless Camera", "Canon EOS 90D DSLR Camera", "Sony a7 IV Mirrorless Camera", "Sony a6600 Mirrorless Camera", "Sony a7 III Mirrorless Camera", "Sony a6400 Mirrorless Camera", "Sony a7R IV Mirrorless Camera", "Sony a7S III Mirrorless Camera", "Sony ZV-E10 Mirrorless Camera", "Sony a9 II Mirrorless Camera", "Sony a7C Mirrorless Camera", "Sony a6100 Mirrorless Camera", "Nikon Z6 II Mirrorless Camera", "Nikon Z7 II Mirrorless Camera", "Nikon D3500 DSLR Camera", "Nikon D850 DSLR Camera", "Nikon Z fc Mirrorless Camera", "Nikon D7500 DSLR Camera", "Nikon Z5 Mirrorless Camera", "Fujifilm X-H2S Mirrorless Camera", "Fujifilm X-T30 II Mirrorless Camera", "Panasonic Lumix G7 Mirrorless Camera", "Fujifilm X-S10 Mirrorless Camera", "Panasonic Lumix GH6 Mirrorless Camera", "Fujifilm X-T4 Mirrorless Camera", "Panasonic Lumix GH5 II Mirrorless Camera", "Vest Pocket Autographic Kodak Camera", "Kodak 616 Junior Camera", "Kodak 35 Camera", "Kodak PIXPRO FZ43 16MP Digital Camera", "Kodak PIXPRO AZ252 16.15MP Digital Camera", "Kodak PIXPRO FZ152 16MP Digital Camera", "Kodak PIXPRO AZ241 16.15MP Digital Camera", "Kodak PIXPRO AZ401 16MP Digital Camera", "Kodak Smile 10MP Digital Camera", "Yashica T4 Camera", "Konica Hexar AF Camera", "Nikon L35AF Camera", "Olympus XA2 Camera", "Olympus OM-1 Camera", "Nikon F2 Camera", "Nikon FE Camera", "Pentax 67 Camera", "Pentax K1000 Camera", "Canon AE-1 Camera", "Canon A2/A2e Camera", "Plaubel Makina W67 Camera", "Lubitel 2", "Kodak No 3A Folding Pocket Camera", "Canon G III QL17 Camera", "Polaroid SX-70 Alpha Camera", "Graflex Century Graphic 2×3 Camera", "Pentacon Six TL Camera", "Zenza Bronica ETRSi Camera", "Hasselblad 500C Camera", "Contax G1/G2 Camera", "Leica M3 Double Stroke Camera", "Leica M6 Camera", "Horseman 4×5 (45HD) Camera", "Mamiya 7 II Camera"],

    "lighting": lightModifiers,
};

let realism = [
    {"name": "resolution", "keywords": ["2k resolution", "4k resolution", "8k resolution", "12k resolution"]},
    {
        "name": "realism",
        "keywords": ["accurate lighting", "believable depth of field", "convincing movement", "high resolution", "lifelike textures", "naturalistic colors", "photorealistic details", "realistic reflections", "realistic shadows", "realistic skin tones", "realistic textures", "realistic weather effects", "sharp focus", "true-to-life details"]
    },
    {
        "name": "optional",
        "keywords": ["16k resolution", "32k resolution", "High resolution", "High definition", "HD", "HDR"]
    }
];

let newStyles = [
    {
        name: "Radiace",
        id: "radiance",
        "details": "centered, symmetry, painted, intricate, volumetric lighting, beautiful, rich deep colors masterpiece, sharp focus, ultra detailed, in the style of dan mumford and marc simonetti, astrophotography"
    }, {
        name: "Lush Forest",
        id: "lush_illustration",
        "details": "unreal engine, greg rutkowski, loish, rhads, beeple, makoto shinkai and lois van baarle, ilya kuvshinov, rossdraws, tom bagshaw, alphonse mucha, global illumination, detailed and intricate environment"
    }, {
        name: "Saturated Space",
        id: "saturated_space",
        "details": "outer space, vanishing point, super highway, high speed, digital render, digital painting, beeple, noah bradley, cyril roland, ross tran, trending on artstation"
    }, {
        name: "Neon Mecha",
        id: "neon_mecha",
        "details": "neon ambiance, abstract black oil, gear mecha, detailed acrylic, grunge, intricate complexity, rendered in unreal engine, photorealistic"
    }, {
        name: "Ethereal Low poly",
        id: "ethereal_low_poly",
        "details": "low poly, isometric art, 3d art, high detail, artstation, concept art, behance, ray tracing, smooth, sharp focus, ethereal lighting"
    }, {
        name: "Warm box",
        id: "warm_box",
        "details": "golden ratio, fake detail, trending pixiv fanbox, acrylic palette knife, style of makoto shinkai studio ghibli genshin impact james gilleard greg rutkowski chiho aoshima"
    }, {
        name: "Cinematic",
        id: "cinematic",
        "details": "perfect composition, beautiful detailed intricate insanely detailed octane render trending on artstation, 8 k artistic photography, photorealistic concept art, soft natural volumetric cinematic perfect light, chiaroscuro, award - winning photograph, masterpiece, oil on canvas, raphael, caravaggio, greg rutkowski, beeple, beksinski, giger"
    }, {
        name: "Cinematic (warm)",
        id: "cinematic_warm",
        "details": "sharp focus, emitting diodes, smoke, artillery, sparks, racks, system unit, motherboard, by pascal blanche rutkowski repin artstation hyperrealism painting concept art of detailed character design matte painting, 4 k resolution blade runner"
    },
    {
        name: "Wasteland",
        id: "wasteland",
        "details": "isometric, digital art, smog, pollution, toxic waste, chimneys and railroads, 3 d render, octane render, volumetrics, by greg rutkowski"
    }, {
        name: "Flat palette",
        id: "flat_palette",
        "details": "acrylic painting, trending on pixiv fanbox, palette knife and brush strokes, style of makoto shinkai jamie wyeth james gilleard edward hopper greg rutkowski studio ghibli genshin impact"
    }, {
        name: "Ominous escape",
        id: "ominous_escape",
        "details": "professional ominous concept art, by artgerm and greg rutkowski, an intricate, elegant, highly detailed digital painting, concept art, smooth, sharp focus, illustration, in the style of simon stalenhag, wayne barlowe, and igor kieryluk."
    }, {
        name: "Spielberg",
        id: "spielberg",
        "details": "cinematic, 4k, epic Steven Spielberg movie still, sharp focus, emitting diodes, smoke, artillery, sparks, racks, system unit, motherboard, by pascal blanche rutkowski repin artstation hyperrealism painting concept art of detailed character design matte painting, 4 k resolution blade runner"
    }, {
        name: "Royalistic",
        id: "royalistic",
        "details": "epic royal background, big royal uncropped crown, royal jewelry, robotic, nature, full shot, symmetrical, Greg Rutkowski, Charlie Bowater, Beeple, Unreal 5, hyperrealistic, dynamic lighting, fantasy art"
    }, {
        name: "Masterpiece",
        id: "masterpiece",
        "details": "sf, intricate artwork masterpiece, ominous, matte painting movie poster, golden ratio, trending on cgsociety, intricate, epic, trending on artstation, by artgerm, h. r. giger and beksinski, highly detailed, vibrant, production cinematic character render, ultra high quality model"
    }, {
        name: "Wall Art",
        id: "wall_art",
        "details": "by Jacob Lawrence and Francis picabia, perfect composition, beautiful detailed intricate insanely detailed octane render trending on artstation, 8 k artistic photography, photorealistic concept art, soft natural volumetric cinematic perfect light, chiaroscuro, award - winning photograph, masterpiece, oil on canvas, raphael, caravaggio, greg rutkowski, beeple, beksinski, giger"
    }, {
        name: "Haze",
        id: "haze",
        "details": "haze, ultra-detailed, film photography, light leaks, Larry Bud Melman, trending on artstation, sharp focus, studio photo, intricate details, highly detailed, by greg rutkowski"
    },
    {
        name: "Black and white (3D)",
        id: "black_and_white_3d",
        "details": "black and white still, digital Art, perfect composition, beautiful detailed intricate insanely detailed octane render trending on artstation, 8 k artistic photography, photorealistic concept art, soft natural volumetric cinematic perfect light, chiaroscuro, award - winning photograph, masterpiece, oil on canvas, raphael, caravaggio, greg rutkowski, beeple, beksinski, giger"
    }, {
        name: "Cinematic dimensions",
        id: "cinematic_dimensions",
        "details": "perfect composition, beautiful detailed intricate insanely detailed octane render trending on artstation, 8 k artistic photography, photorealistic concept art, soft natural volumetric cinematic perfect light, chiaroscuro, award - winning photograph, masterpiece, oil on canvas, raphael, caravaggio, greg rutkowski, beeple, beksinski, giger"
    }, {
        name: "Futuristic illumination",
        id: "futuristic_illumination",
        "details": "futuristic illumination, Art Deco, Full colors, Greg rutkowski, Trending artstation, cinematogr\xe1fic"
    }, {
        name: "Photorealistic",
        id: "photorealistic",
        "details": "digital Art, perfect composition, beautiful detailed intricate insanely detailed octane render trending on artstation, 8 k artistic photography, photorealistic concept art, soft natural volumetric cinematic perfect light, chiaroscuro, award - winning photograph, masterpiece, oil on canvas, raphael, caravaggio, greg rutkowski, beeple, beksinski, giger"
    }, {
        name: "Cinematic (cold)",
        id: "cinematic_cold",
        "details": "sf, intricate artwork masterpiece, ominous, matte painting movie poster, golden ratio, trending on cgsociety, intricate, epic, trending on artstation, by artgerm, h. r. giger and beksinski, highly detailed, vibrant, production cinematic character render, ultra high quality model"
    }, {
        name: "Cute low poly 3D",
        id: "cute_low_poly_3d",
        "details": "cute isometric low polygon 3d render, white background, ambient occlusion, chibi, angular"
    }, {
        name: "Nikon mode",
        id: "nikon_mode",
        "details": "Nikon D3100 | ISO 450 | focal length 50 mm (Sigma 50mm f1.5) | aperture f/4 | exposure time 1/250 Sec (DRI)"
    },
    {
        name: "Yellow fog",
        id: "yellow_fog",
        "details": "futuristic, yellow theme fog, unreal engine, centered, symmetry, painted, intricate, volumetric lighting, beautiful, rich deep colors masterpiece, sharp focus, ultra detailed, in the style of dan mumford and marc simonetti, astrophotography"
    }, {
        name: "Moody impressions",
        id: "moody_impressions",
        "details": "moody lighting, 8 k resolution, octane render, trending on artstation, by h. r. giger and greg rutkowski , haze, ultra-detailed, film photography, light leaks, Larry Bud Melman, trending on artstation, sharp focus, studio photo, intricate details, highly detailed, by greg rutkowski"
    }, {
        name: "Portrait",
        id: "portrait",
        "details": "a 70mm portrait, iso 100, focus mode, f/100, smiling brightly, waist up photo, locs, blasian, perfect composition, beautiful detailed intricate insanely detailed octane render trending on artstation, 8 k artistic photography, photorealistic concept art, soft natural volumetric cinematic perfect light, chiaroscuro, award - winning photograph, masterpiece, oil on canvas, raphael, caravaggio, greg rutkowski, beeple, beksinski, giger"
    }, {
        name: "Hypersonic",
        id: "hypersonic",
        "details": "hypersonic, 8k, stunning quality, octane render, trending on artstation, sharp focus, studio photo, intricate details, highly detailed, by greg rutkowski"
    }, {
        name: "Close up portrait",
        id: "closeup",
        "details": "close up portrait photo by Annie Leibovitz, film, studio lighting, detailed skin, ultra realistic, bokeh, sharp features",
        negativePrompt: "cartoon, 3d, disfigured, bad art, deformed, poorly drawn, extra limbs, close up, b&w, weird colors, blurry, watermark"
    }, {
        name: "Old timey",
        id: "old-timey",
        "details": "a black and white photo, inspired by Bert Hardy, pexels contest winner, inspired by Vivian Maier, flickr, 1940s, high quality photo, afp",
        // negativePrompt: "lowres, bad hands, text, error, missing fingers, extra digit, fewer digits, cropped, worst quality, low quality, normal quality, jpeg artifacts, signature, watermark, picture frame"
    },
    {
        name: "Futuristic City",
        id: "futuristic_city",
        "details": "3D rendered, highly detailed, intricate, futuristic cityscape, rendered in unreal engine, photorealistic, inspired by the work of Syd Mead and Beeple"
    },
    {
        name: "Surreal Landscape",
        id: "surreal_landscape",
        "details": "Digital painting, surreal, dreamlike, detailed, intricate, in the style of H.R. Giger and Salvador Dali, rendered in Procreate"
    },
    {
        name: "Retro Futurism",
        id: "retro_futurism",
        "details": "Retro futuristic, vintage, 1950s-inspired, highly detailed, intricate, digital painting, inspired by the work of Jean Giraud (Moebius) and Syd Mead"
    },
    {
        name: "Cyberpunk Noir",
        id: "cyberpunk_noir",
        "details": "Black and white, cyberpunk, gritty, neon, detailed, intricate, digital painting, inspired by the work of William Gibson and Beeple"
    },
    {
        name: "Steampunk",
        id: "steampunk",
        "details": "Steampunk, retro-futuristic, Victorian-inspired, detailed, intricate, digital painting, inspired by the work of Jules Verne and Hayao Miyazaki"
    },
    {
        name: "Neon Dreams",
        id: "neon_dreams",
        "details": "Neon, dreamlike, surreal, detailed, intricate, digital painting, rendered in Procreate, inspired by the work of Krista Kim and Beeple"
    }, {
        name: "Fantasy Landscape",
        id: "fantasy_landscape",
        "details": "Digital painting, fantasy, detailed, intricate, in the style of Yoshitaka Amano and J.R.R. Tolkien, rendered in Corel Painter"
    }, {
        name: "Alien Invasion",
        id: "alien_invasion",
        "details": "Alien, sci-fi, detailed, intricate, digital painting, inspired by the work of H.R. Giger and Scott Campbell, rendered in Adobe Photoshop"
    }, {
        name: "Retro Future",
        id: "retro_future",
        "details": "Retro, futuristic, detailed, intricate, digital painting, inspired by the work of Syd Mead and Jean Giraud (Moebius), rendered in Adobe Illustrator"
    }, {
        name: "Cyberpunk City",
        id: "cyberpunk_city",
        "details": "Cyberpunk, neon, detailed, intricate, digital painting, inspired by the work of William Gibson and Shusei Nagaoka, rendered in Adobe Photoshop"
    },
    {
        name: "Post Apocalyptic",
        id: "post_apocalyptic",
        "details": "Post apocalyptic, gritty, detailed, intricate, digital painting, inspired by the work of George Miller and Simon Stalenhag, rendered in Adobe Photoshop"
    }, {
        name: "Sci-Fi City",
        id: "sci-fi_city",
        "details": "Sci-fi, detailed, intricate, digital painting, inspired by the work of Syd Mead and Chris Foss, rendered in Corel Painter"
    }, {
        name: "Futuristic Landscape",
        id: "futuristic_landscape",
        "details": "Futuristic, detailed, intricate, digital painting, inspired by the work of James Gurney and Beeple, rendered in Procreate"
    }, {
        name: "Surreal City",
        id: "surreal_city",
        "details": "Surreal, dreamlike, detailed, intricate, digital painting, inspired by the work of H.R. Giger and Salvador Dali, rendered in Adobe Illustrator"
    }, {
        name: "Mecha",
        id: "mecha",
        "details": "Mecha, detailed, intricate, digital painting, inspired by the work of Yoshitaka Amano and Kōji Morimoto, rendered in Adobe Photoshop"
    },
    {
        name: "Vintage Noir",
        id: "vintage_noir",
        "details": "Vintage, black and white, gritty, detailed, intricate, in the style of classic film noir movies, rendered in Adobe Photoshop"
    }, {
        name: "Retro Sci-Fi",
        id: "retro_sci-fi",
        "details": "Retro, sci-fi, detailed, intricate, in the style of 1950s sci-fi movies, rendered in Adobe Illustrator"
    }, {
        name: "Vintage Horror",
        id: "vintage_horror",
        "details": "Vintage, horror, detailed, intricate, in the style of 1930s-1950s horror movies, rendered in Corel Painter"
    }, {
        name: "Retro Action",
        id: "retro_action",
        "details": "Retro, action, detailed, intricate, in the style of 1970s-1980s action movies, rendered in Procreate"
    },

    {
        name: "Magical Forest",
        id: "magical_forest",
        "details": "Magical, dreamlike, detailed, intricate, digital painting, inspired by the work of Hayao Miyazaki and John Howe, rendered in Adobe Photoshop"
    }, {
        name: "Fantasy Castle",
        id: "fantasy_castle",
        "details": "Fantasy, detailed, intricate, digital painting, inspired by the work of Alan Lee and Frank Frazetta, rendered in Corel Painter"
    }, {
        name: "Mystical Valley",
        id: "mystical_valley",
        "details": "Mystical, dreamlike, detailed, intricate, digital painting, inspired by the work of Richard Corben and Jean Giraud (Moebius), rendered in Procreate"
    }, {
        name: "Steampunk City",
        id: "steampunk_city",
        "details": "Steampunk, detailed, intricate, digital painting, inspired by the work of Katsuhiro Otomo and Syd Mead, rendered in Adobe Illustrator"
    }, {
        name: "Enchanted Garden",
        id: "enchanted_garden",
        "details": "Enchanted, dreamlike, detailed, intricate, digital painting, inspired by the work of Hayao Miyazaki and Brian Froud, rendered in Adobe Photoshop"
    }, {
        name: "Fairytale Village",
        id: "fairytale_village",
        "details": "Fairytale, detailed, intricate, digital painting, inspired by the work of Arthur Rackham and Alan Lee, rendered in Corel Painter"
    }, {
        name: "Surreal Jungle",
        id: "surreal_jungle",
        "details": "Surreal, dreamlike, detailed, intricate, digital painting, inspired by the work of H.R. Giger and Alex Grey, rendered in Procreate"
    }, {
        name: "Space Station",
        id: "space_station",
        "details": "Space, sci-fi, detailed, intricate, digital painting, inspired by the work of Chris Foss and Syd Mead, rendered in Adobe Illustrator"
    }, {
        name: "High Fantasy",
        id: "high_fantasy",
        "details": "High fantasy, detailed, intricate, digital painting, inspired by the work of Frank Frazetta and J.R.R. Tolkien, rendered in Adobe Photoshop"
    }, {
        name: "Robot Factory",
        id: "robot_factory",
        "details": "Robot, sci-fi, detailed, intricate, digital painting, inspired by the work of Katsuhiro Otomo and Masamune Shirow, rendered in Corel Painter"
    },{
        name: "Sci-Fi Landscape",
        id: "sci-fi_landscape",
        "details": "Sci-fi, detailed, intricate, digital painting, inspired by the work of John Berkey and Syd Mead, rendered in Procreate"
    }, {
        name: "Space Battle",
        id: "space_battle",
        "details": "Space, sci-fi, detailed, intricate, digital painting, inspired by the work of Chris Foss and H.R. Giger, rendered in Adobe Illustrator"
    }, {
        name: "Magical Village",
        id: "magical_village",
        "details": "Magical, dreamlike, detailed, intricate, digital painting, inspired by the work of Brian Froud and Alan Lee, rendered in Adobe Photoshop"
    }, {
        name: "Underwater World",
        id: "underwater_world",
        "details": "Underwater, dreamlike, detailed, intricate, digital painting, inspired by the work of Richard Corben and Hayao Miyazaki, rendered in Corel Painter"
    }, {
        name: "Cyberpunk Metropolis",
        id: "cyberpunk_metropolis",
        "details": "Cyberpunk, neon, detailed, intricate, digital painting, inspired by the work of William Gibson and Masamune Shirow, rendered in Procreate"
    },{
        name: "Spaghetti Western",
        id: "spaghetti_western",
        "details": "Western, detailed, intricate, digital painting, inspired by the work of Sergio Leone and Clint Eastwood, rendered in Adobe Photoshop"
    }, {
        name: "Blaxploitation",
        id: "blaxploitation",
        "details": "Blaxploitation, gritty, detailed, intricate, digital painting, inspired by the work of Melvin Van Peebles and Gordon Parks, rendered in Corel Painter"
    }, {
        name: "Kung Fu",
        id: "kung_fu",
        "details": "Kung Fu, martial arts, detailed, intricate, digital painting, inspired by the work of Bruce Lee and Jackie Chan, rendered in Procreate"
    }, {
        name: "Surreal Horror",
        id: "surreal_horror",
        "details": "Surreal, horror, detailed, intricate, digital painting, inspired by the work of Wes Craven and Roman Polanski, rendered in Adobe Illustrator"
    }, {
        name: "Musical",
        id: "musical",
        "details": "Musical, dreamlike, detailed, intricate, digital painting, inspired by the work of Bob Fosse and John Waters, rendered in Adobe Photoshop"
    }, {
        name: "Space Odyssey",
        id: "space_odyssey",
        "details": "Space, sci-fi, detailed, intricate, digital painting, inspired by the work of Stanley Kubrick and Douglas Trumbull, rendered in Corel Painter"
    }, {
        name: "Gangster Film",
        id: "gangster_film",
        "details": "Gangster, gritty, detailed, intricate, digital painting, inspired by the work of Martin Scorsese and Francis Ford Coppola, rendered in Procreate"
    }, {
        name: "Road Movie",
        id: "road_movie",
        "details": "Road movie, detailed, intricate, digital painting, inspired by the work of John Milius and Dennis Hopper, rendered in Adobe Illustrator"
    }, {
        name: "Glam Rock",
        id: "glam_rock",
        "details": "Glam rock, dreamlike, detailed, intricate, digital painting, inspired by the work of David Bowie and Elton John, rendered in Adobe Photoshop"
    }, {
        name: "Comedy",
        id: "comedy",
        "details": "Comedy, quirky, detailed, intricate, digital painting, inspired by the work of Mel Brooks and Woody Allen, rendered in Corel Painter"
    },
    {
        name: "Retro Pop Art",
        id: "retro_pop_art",
        "details": "Retro, Pop Art, detailed, intricate, digital painting, inspired by the work of Roy Lichtenstein and Andy Warhol, rendered in Adobe Photoshop"
    }, {
        name: "Psychedelic Color",
        id: "psychedelic_color",
        "details": "Psychedelic, vivid, detailed, intricate, digital painting, inspired by the work of Peter Max and Peter Blake, rendered in Corel Painter"
    }, {
        name: "Manga Style",
        id: "manga_style",
        "details": "Manga, vibrant, detailed, intricate, digital painting, inspired by the work of Osamu Tezuka and Rumiko Takahashi, rendered in Adobe Illustrator"
    }, {
        name: "Abstract Expressionism",
        id: "abstract_expressionism",
        "details": "Abstract Expressionism, bold, detailed, intricate, digital painting, inspired by the work of Jackson Pollock and Willem de Kooning, rendered in Procreate"
    }, {
        name: "Graffiti Art",
        id: "graffiti_art",
        "details": "Graffiti, gritty, detailed, intricate, digital painting, inspired by the work of Keith Haring and Jean-Michel Basquiat, rendered in Adobe Photoshop"
    }, {
        name: "Cubist Landscape",
        id: "cubist_landscape",
        "details": "Cubist, geometric, detailed, intricate, digital painting, inspired by the work of Pablo Picasso and Georges Braque, rendered in Corel Painter"
    }, {
        name: "Retro Space",
        id: "retro_space",
        "details": "Retro, space-age, detailed, intricate, digital painting, inspired by the work of Ray Harryhausen and Roger Dean, rendered in Adobe Illustrator"
    }, {
        name: "Futuristic Surrealism",
        id: "futuristic_surrealism",
        "details": "Futuristic, surreal, detailed, intricate, digital painting, inspired by the work of Salvador Dali and René Magritte, rendered in Procreate"
    }, {
        name: "Neon Art",
        id: "neon_art",
        "details": "Neon, vibrant, detailed, intricate, digital painting, inspired by the work of Tracey Emin and Damien Hirst, rendered in Adobe Photoshop"
    },
    {
        name: "Atari",
        id: "atari",
        "details": "Retro-style, pixelated artwork featuring Atari-style graphics from the 1980s"
    },{
        name: "VHS",
        id: "vhs",
        "details": "Grainy, low-resolution artwork featuring distorted VHS textures and inspired by vintage Time magazine ads from the 80s"
    },{
        name: "MTV",
        id: "mtv",
        "details": "Psychedelic, vibrant artwork featuring MTV-inspired graphics and typography, inspired by 80s Time magazine ads"
    },{
        name: "Neon Signs",
        id: "neon_signs",
        "details": "Neon-colored artwork featuring vibrant, 80s-style signs and inspired by vintage Time magazine advertisements"
    },{
        name: "Retro",
        id: "retro",
        "details": "Retro-style artwork featuring muted colors and bold, stylized typography, inspired by classic Time magazine ads from the 80s"
    },

];
let medium3D = [
    "3D Renderings",
    "3D Path Tracing",
    "3D Ray Tracing",
    "3D Sculpting",
];
let trendingOn = ["trending on ArtStation", "trending on ConceptArtWorld", "trending on Flickr", "trending on Behance", "trending on 500px", "trending on Getty Images", "trending on DeviantArt", "trending on Pixiv", "trending on IllustrationX", "trending on CGSociety", "trending on Unsplash", "trending on Google Images", "trending on Pinterest", "trending on Sketchfab", "trending on Artsy", "National Gallery of Art Highlights", "trending on Saatchi Art"];
let traditionalMediums = ["Oil Painting", "acrylic painting", "Graphite pencil drawing", "Watercolors painting", "Color Pencil drawing", "Technical drawing", "Charcoal drawing", "Botanical Drawing", "Pastel drawing", "Chalk drawing", "Optical Illusion"];
let digitalMedium = ["Retro Graphics", "Digital Painting", "Concept Artist", "Vector Art", "Dynamic Painting", "Matte Painting", "Digital Matte Painting", "Digital Collage", "2D Digital Painting", "3D Digital Painting", "Integrated Art", "2D Animation", "Mixed-Medium Art", "Raster Painting", "Generative Art"];
let experimentalDigitalMediums = ["Low Poly", "Pixel Art", "Voxel", "Fractal Art", "Data-Moshing", "Algorithmic Art", "PSX GRAPHICS"];
let experimentalMediums = ["Done in LEGO", "Play-Doh", "Diorama", "Miniature", "Terrarium", "Paper Cut Out", "Linocut", "made of yarn", "Origami"];
let fun = {experimentalMediums, experimentalDigitalMediums};

let artMedium = [{name: "traditional", traditionalMediums}, {
    name: "digital",
    digitalMedium
}, {name: "fun", ...fun}];
let modernArt = {
    name: 'modern art',
    keywords: [
        "60s kitsch and psychedelia",
        "abstract illusionism",
        "brutalism",
        "chillwave",
        "dark academia",
        "fractalism",
        "futuresynth",
        "glitch art",
        "graffiti",
        "hyperrealism",
        "retrowave",
        "surrealism",
        "synthwave",
        "vaporwave"
    ]
};
let contemporaryArt = {
    name: "contemporary art", keywords: [
        "cottagecore",
        "Lovecraftian",
        "magic realism",
        "narrative realism",
        "photorealism",
        "realism",
        "still life",
        "street art"
    ]
};
let classicalArt = {
    name: "Classical Art", keywords: [
        "avant-garde",
        "cubism",
        "expressionism",
        "figurativism",
        "gothic",
        "impressionism",
        "modernism",
        "naturalism",
        "positivism",
        "stuckism",
        "symbolism",
        "the matrix",
        "tonalism",
        "american romanticism",
        "dutch golden age",
        "german romanticism"
    ]
};
let compositions = ["rule of thirds", "golden ratio", "golden spiral", "golden rectangle", "golden triangle", "Rule of Thirds", "Golden Ratio", "Diagonals", "Leading Lines", "Symmetry", "Asymmetry", "Balanced composition", "Focal Point", "Negative Space", "Overlapping", "Cropping", "Frame within a frame"];
let compositionSuggestions = ["Use rule of thirds composition", "Center the subject", "Use the golden ratio composition", "Use the golden spiral composition", "Use diagonals in the composition", "Use leading lines in the composition", "Use symmetry in the composition", "Use asymmetry in the composition", "Use balanced composition", "strong focal point in the composition", "Use negative space in the composition",];
let photographyColorGradeProfile = ["Cinematic", "Film", "Sepia", "Vignette", "Vintage", "HDR", "Saturated", "X-Pro II", "Lomo filter", "Analog Film", "Analog Film Grain", "Analog Film Light Leak",];
let artMovements = [modernArt, contemporaryArt, classicalArt];
let colorPalettes = [
    ...movieTones,
    ...colorSchemes,
    ...colorTones
];
let terms3d = [
    ...medium3D,
    "Ambient Occlusion",
    "Anti-aliasing",
    "Direct Lighting",
    "Global Illumination",
    "Wireframe Model",
    "Wireframe Rendering",
    "Chromatic Abberation",
    "2D Sprite",
    "Ambient Lighting",
    "Augmented Reality",
    "Post Processed",
    "Ray Traced",
    "Bitmap",
    "Cel shading",
    "Flat shading",
    "FXAA",
    "Indirect Illumination",
    "Lumen Global Illumination",
    "Manhattan Distance",
    "Microdisplacement",
    "Nanite Geometry",
    "Path Traced",
    "PBR Material",
    "Phong Shading",
    "Physically based rendering (PBR)",
    "Procedural Generation",
    "Procedural Texture",
    "Raster graphics",
    "Screen space ambient occlusion",
    "Skybox",
    "Terrain rendering",
    "Tesselation",
    "Virtual reality",
    "Volumetric Lighting",
    "Voronoi Manhattan",
    "Voronoi Minkowski",
    "Voxel Engine",
    "Voxel Geometry"
];
let photographyTechniques = [
    "ambrotype",
    "anaglyph effect",
    "anaglyph filter",
    "blueprint",
    "calotype",
    "camcorder effect",
    "daguerreotype",
    "doge",
    "fisheye lens",
    "holography",
    "inverted colors",
    "long exposure",
    "macro lens",
    "manga",
    "optical illusion",
    "telephoto lens",
    "tilt-shift",
    "tintype"
];
let data = {
    portraitStyles,
    camera,
    lightingStyles,
    realism,
    newPortraitStyles,
    artMovements,
    artMedium,
    colorPalettes,
    imageStaging,
    newStyles,
    genreMods: [
        "60s kitsch and psychedelia",
        "abstract illusionism",
        "ambrotype",
        "american romanticism",
        "anaglyph effect",
        "anaglyph filter",
        "blueprint",
        "brutalism",
        "chillwave",
        "cottagecore",
        "crayon art",
        "cyanotype",
        "dark academia",
        "digital art",
        "dutch golden age",
        "fractalism",
        "fresco",
        "futuresynth",
        "german romanticism",
        "glitch art",
        "gothic art",
        "graffiti",
        "hyperrealism",
        "infrared",
        "Lovecraftian",
        "magic realism",
        "multiple exposure",
        "narrative realism",
        "photorealism",
        "realism",
        "retrowave",
        "Sabattier effect",
        "Sabattier filter",
        "still life",
        "street art",
        "surrealism",
        "synthwave",
        "vaporwave",
        "afrofuturism",
        "anime",
        "avant-garde",
        "calotype",
        "camcorder effect",
        "cubism",
        "daguerreotype",
        "doge",
        "expressionism",
        "figurativism",
        "fisheye lens",
        "gothic",
        "holography",
        "impressionism",
        "inverted colors",
        "long exposure",
        "mac and cheese",
        "macro lens",
        "manga",
        "modernism",
        "naturalism",
        "optical illusion",
        "positivism",
        "stuckism",
        "symbolism",
        "telephoto lens",
        "the matrix",
        "tilt-shift",
        "tintype",
        "tonalism"
    ],
    trendingOn,
    artInspirations: [
        "Abstract Expressionism: Jackson Pollock",
        "Art Nouveau: Alphonse Mucha",
        "Conceptual Art: Joseph Kosuth",
        "Cubism: Pablo Picasso",
        "Dada: Marcel Duchamp",
        "Expressionism: Vincent Van Gogh",
        "Fantasy Art: J.R.R Tolkien",
        "Futurism: Gino Severini",
        "Hyperrealism: Claudio Bravo",
        "Impressionism: Claude Monet",
        "Installation Art: Christo",
        "Land Art: Robert Smithson",
        "Minimalism: Donald Judd",
        "Neo-Expressionism: Georg Baselitz",
        "Neo-Pop: Jeff Koons",
        "Op Art: Victor Vasarely",
        "Performance Art: Marina Abramovic",
        "Photorealism: Chuck Close",
        "Pop Art: Andy Warhol",
        "Realism: Chuck Close",
        "Surrealism: Salvador Dali",
    ],
    photographyInspirations: [
        "Aerial Photography: Yann Arthus-Bertrand",
        "Black and White Photography: Robert Capa",
        "Documentary Photography: Dorothea Lange",
        // "Sports Photography: David Burnett",
        "Fashion Photography: Helmut Newton",
        "Fine Art Photography: Andreas Gursky",
        "Food Photography: David LaChapelle",
        "Landscape Photography: Ansel Adams",
        "Macro Photography: Art Wolfe",
        "Nature Photography: Frans Lanting",
        "Portrait Photography: Annie Leibovitz",
        "Still Life Photography: Irving Penn",
        "Street Photography: Henri Cartier-Bresson",
        "Travel Photography: Steve McCurry",
        "Underwater Photography: David Doubilet",
        "Wildlife Photography: Steve McCurry",
        // "Astrophotography: Michael Benson",
        // "Time-Lapse Photography: Tom Lowe",
        // "Infrared Photography: Michael Kenna",
        // "Tilt-Shift Photography: Ben Thomas"
    ],
    promptModifiers: [
        "3D rendering",
        "4k/8k",
        "Award-Winning Art",
        "character design",
        "concept art",
        "digital painting",
        "photo-manipulation",
        "photorealistic",
        "trending on Artstation",
        "ultrarealistic editorial photograph",
        "unreal engine",
    ],
    stylized: [
        "Vibrant, abstract, with bold shapes and lines and high resolution",
        "Futuristic, sleek, with metallic surfaces, neon lighting and sharp focus",
        "Ethereal, dreamlike, with soft focus and misty landscapes, and sharp details"
    ],
    artStylesArray: [
        "Abstract Expressionism, with a focus on non-representational forms, gestural brushstrokes, and the artist's emotions, inspired by Jackson Pollock and Mark Rothko",
        "Art Brut, with a focus on raw, untrained, and intuitive art, inspired by Jean Dubuffet and Henry Darger",
        "Art Deco, with a focus on geometric shapes, bold colors, and luxury, inspired by Erte and Tamara de Lempicka",
        "Art Nouveau, with a focus on organic shapes, asymmetry, and ornate decoration, inspired by Alphonse Mucha and Gustav Klimt",
        "Cubism, with a focus on geometric shapes, multiple perspectives, and collage, inspired by Pablo Picasso and Georges Braque",
        "Dada, with a focus on randomness, nonsense, and anti-art sentiments, inspired by Marcel Duchamp and Hannah Höch",
        "Expressionism, with a focus on bold colors, brushstrokes, and emotions, inspired by Vincent Van Gogh and Edvard Munch",
        "Fantasy Art, with a focus on vivid colors, whimsical imagery, and fantastical elements, inspired by J.R.R Tolkien and Brian Froud",
        "Futurism, with a focus on sleek and metallic surfaces, industrial landscapes, and technology, inspired by Gino Severini and H.R Giger",
        "Hyperrealism, with a focus on photorealistic details, textures, and accuracy, inspired by Richard Estes and Denis Peterson",
        "Impressionism, with a focus on light, movement, and color, inspired by Claude Monet and Pierre-Auguste Renoir",
        "Minimalism, with a focus on simplicity, negative space, and geometric shapes, inspired by Donald Judd and Agnes Martin",
        "Neo-Expressionism, with a focus on intense colors, gestural brushstrokes, and raw emotions, inspired by Jean-Michel Basquiat and Julian Schnabel",
        "Op Art, with a focus on optical illusions, geometric shapes, and the interaction of light and color, inspired by Victor Vasarely and Bridget Riley",
        "Pointillism, with a focus on small, distinct dots of color, and optical mixing, inspired by Georges Seurat and Paul Signac",
        "Pop Art, with a focus on popular culture, consumerism, and irony, inspired by Andy Warhol and Roy Lichtenstein",
        "Post-Impressionism, with a focus on emotional and symbolic content, vibrant colors, and thick paint, inspired by Paul Cezanne and Vincent van Gogh",
        "Realism, with a focus on photorealistic details, textures, and accuracy, inspired by Chuck Close and Richard Estes",
        "Rococo, with a focus on ornate and frivolous decoration, asymmetry, and pastel colors, inspired by Fragonard and Jean-Honoré Fragonard",
        "Surrealism, with a focus on disorienting perspectives, abstract shapes, and impossible constructions, inspired by M.C Escher and Salvador Dali",
        "Surrealism, with a focus on dreamlike landscapes, abstract shapes, and a juxtaposition of elements, inspired by Salvador Dali and Max Ernst",
    ],

};
window.imageData = data;
// artStyles: {
//     "Abstract Expressionism": [
//         "Jackson Pollock",
//         "Mark Rothko"
//     ],
//     "Art Nouveau": [
//         "Alphonse Mucha",
//         "Gustav Klimt"
//     ],
//     "Conceptual Art": [
//         "Joseph Kosuth",
//         "Sol LeWitt"
//     ],
//     "Cubism": [
//         "Pablo Picasso",
//         "Georges Braque"
//     ],
//     "Dada": [
//         "Marcel Duchamp",
//         "Hannah Hoch"
//     ],
//     "Expressionism": [
//         "Vincent Van Gogh",
//         "Edvard Munch"
//     ],
//     "Fantasy Art": [
//         "J.R.R Tolkien",
//         "Brian Froud"
//     ],
//     "Futurism": [
//         "Gino Severini",
//         "H.R Giger"
//     ],
//     "Hyperrealism": [
//         "Claudio Bravo",
//         "John Baeder"
//     ],
//     "Impressionism": [
//         "Claude Monet",
//         "Pierre-Auguste Renoir"
//     ],
//     "Installation Art": [
//         "Christo",
//         "Jeanne-Claude"
//     ],
//     "Land Art": [
//         "Robert Smithson",
//         "Michael Heizer"
//     ],
//     "Minimalism": [
//         "Donald Judd",
//         "Agnes Martin"
//     ],
//     "Neo-Expressionism": [
//         "Georg Baselitz",
//         "Anselm Kiefer"
//     ],
//     "Neo-Pop": [
//         "Jeff Koons",
//         "Damien Hirst"],
//     "Op Art": [
//         "Victor Vasarely",
//         "Bridget Riley"
//     ],
//     "Performance Art": [
//         "Marina Abramovic",
//         "Yoko Ono"
//     ],
//     "Photorealism": [
//         "Chuck Close",
//         "Richard Estes"
//     ],
//     "Pop Art": [
//         "Andy Warhol",
//         "Roy Lichtenstein"
//     ],
//     "Realism": [
//         "Chuck Close",
//         "Richard Estes"
//     ],
//     "Surrealism": [
//         "Salvador Dali",
//         "Max Ernst",
//         "M.C Escher"
//     ],
// },

// "artist-surreal": [
//     "Art et Liberte",
//     "Aase Berg",
//     "Yutaka Bito",
//     "Bodo",
//     "Victor Brauner",
//     "Emmy Bridgwater",
//     "Robert Campbell ",
//     "Giorgio de Chirico",
//     "William Copley ",
//     "Joao Artur da Silva",
//     "Elba Damast",
//     "Paul Delvaux",
//     "Karina Eibatova",
//     "Harold Elliott",
//     "Max Ernst",
//     "Ewa Juszkiewicz",
//     "Agustin Fernandez ",
//     "Ichiro Fukuzawa",
//     "Abdel Hadi Al Gazzar",
//     "Emma Geary",
//     "Alberto Giacometti",
//     "Arshile Gorky",
//     "Jane Graverol",
//     "Henriette Grindat",
//     "Moosa Al Halyan",
//     "Irene Hamoir",
//     "Gilberto Hernandez Ortega",
//     "Kati Horna",
//     "Tetsuya Ishida",
//     "Alpo Jaakola",
//     "Frida Kahlo",
//     "Ida Kar",
//     "Yuki Katsura",
//     "Hiroshi Katsuragawa",
//     "Rita Kernn-Larsen",
//     "Greta Knutson",
//     "Harue Koga",
//     "Wifredo Lam",
//     "Rene Magritte",
//     "Joyce Mansour",
//     "Roberto Matta",
//     "Lise Mayer",
//     "Emila Medkova",
//     "Ahmed Morsi",
//     "Polly Nor",
//     "Meret Oppenheim",
//     "Olga Orozco",
//     "Kiyoji Otsuji",
//     "Wolfgang Paalen",
//     "Ihor Podolchak",
//     "Joyce Reopel",
//     "Aminollah Rezaei",
//     "Guia Risari",
//     "Erna Rosenstein",
//     "Pablo Runyan",
//     "Xanti Schawinsky",
//     "Eva Svankmajerova",
//     "Alina Szapocznikow",
//     "Enrique Tabara",
//     "Dorothea Tanning",
//     "Herve Telemaque",
//     "Blanca Varela",
//     "Rinat Voligamsi",
//     "Kikuji Yamashita",
//     "Ramses Younan",
//     "Haifa Zangana",
//     "Nele Zirnite",
//     "Unica Zurn"
// ],
// "games": [
//     "8-bit JRPG",
//     "A Short Hike",
//     "Age of Empires",
//     "Albion",
//     "Alone in the Dark",
//     "Angry Birds",
//     "Animal Crossing",
//     "Baldur's Gate II",
//     "Baldurs Gate",
//     "Bastion",
//     "Battle Axe",
//     "BioShock",
//     "Blizzard",
//     "Cadillacs and Dinosaurs",
//     "Candy Crush",
//     "Carmen Sandiego",
//     "Castle Wolfenstein",
//     "Castlevania",
//     "Chrono Trigger",
//     "Civilization V",
//     "Command & Conquer Red Alert",
//     "Commander Keen",
//     "Crusaider No Regret",
//     "Dark Souls",
//     "Darkest Dungeon",
//     "Day of the Tentacle",
//     "Desert Strike",
//     "Diablo 2",
//     "Diablo",
//     "Disco Elysium",
//     "Discworld",
//     "Divinity Original Sin",
//     "Doom",
//     "Dota 2",
//     "Dune",
//     "Escape from Monkey Island",
//     "Factorio",
//     "Fall out",
//     "Final Fantasy",
//     "Full Throttle",
//     "Full Throttle",
//     "Game Boy Advance",
//     "Game Boy Color",
//     "Game Boy",
//     "God of War",
//     "Grand Theft Auto III",
//     "Grim dawn",
//     "Grim Fandango",
//     "GTA 1",
//     "GTA 2",
//     "GTA V",
//     "Half-Life",
//     "Harvest Moon",
//     "I Have No Mouth And I Must Scream",
//     "Indiana Jones and the Fate of Atlantis",
//     "JRPG",
//     "League of Legends",
//     "Legend of Mana",
//     "Leisure Suit Larry",
//     "Lemmings",
//     "Little Big Adventure",
//     "Loom",
//     "LucasArts adventure games",
//     "LucasArts",
//     "Magic Carpet",
//     "Maniac Mansion",
//     "Mario Galaxy",
//     "Mario Odissey",
//     "Marvel vs. Capcom",
//     "MDK",
//     "Metal Slug",
//     "Metroid Prime",
//     "Minecraft",
//     "Monster Rancher",
//     "Monument Valley",
//     "Mortal Kombat",
//     "Myst",
//     "Neverwinter Nights",
//     "Nintendo DS",
//     "Nintendo N64",
//     "Nintendo",
//     "Overwatch",
//     "Path of Exile",
//     "Plants vs zombies",
//     "Playstation 1",
//     "Playstation 2",
//     "Pokemon",
//     "Portal 2",
//     "Prince of Persia",
//     "Priston Tale",
//     "PS One",
//     "Quake",
//     "Ragnarok",
//     "Raptor Call of the Shadows",
//     "Red Dead Redemption 2",
//     "Redneck Rampage",
//     "Resident Evil",
//     "Retro RPG",
//     "Rimworld",
//     "Rockstar Games",
//     "Roler Coaster Tycoon",
//     "Runescape",
//     "Sam & Max Hit the Road",
//     "Samorost",
//     "ScummVM",
//     "Shadowrun",
//     "Sid Meier’s Civilization",
//     "Simant",
//     "Simcity 2000",
//     "Simcity 3000",
//     "Simon the Sorcerer",
//     "Skyrim",
//     "Sony",
//     "Square Enix",
//     "Star wars KOTOR",
//     "Star wars yoda stories",
//     "Starcraft",
//     "Stardew Valley",
//     "Starfox",
//     "Street Fighter",
//     "Super Mario Bros 3",
//     "Super Mario RPG",
//     "Super Mario World",
//     "Super Metroid",
//     "Super Nintendo",
//     "Superfrog",
//     "Syndicate",
//     "Team Fortress 2",
//     "Tetris",
//     "The Chaos Engine",
//     "The Dig",
//     "The Elder Scrolls",
//     "The Elder Scrolls",
//     "The Incredible Machine",
//     "The Journey Down",
//     "The Last of Us",
//     "The Legend of Zelda",
//     "The Lord of the Rings",
//     "The Secret of Monkey Island",
//     "The Witcher",
//     "Theme Park",
//     "Thief",
//     "Tibia",
//     "Tomb Raider",
//     "Tony Hawk's Pro Skater 2",
//     "Transport Tycoon",
//     "Tropico 5",
//     "Tyrian",
//     "Ultima Online",
//     "Undertale",
//     "Warcraft",
//     "Wing Commander",
//     "World of Warcraft",
//     "X-Com UFO Defense",
//     "X-men",
//     "Yoshi's Island",
//     "Zak McKracken and the Alien Mindbenders"
// ],

export default data;


